//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { environment } from "src/environments/environment";
export default class ClientBase {
  getBaseUrl(_data: string, _baseUrl?: string): string {
    return environment.apiURL;
  }
  public transformOptions(options: RequestInit): Promise<RequestInit> {
    return new Promise<RequestInit>((resolve) => {
      resolve(options);
    });
  }
}

export interface IActivityClient {

    /**
     * Retrieves products recently visited.
     * @param x_API_PREPARE_ID (Mandatory) Channel request id.
     * @param excludedSKU (optional) SKU to exclude.
     * @return Success
     */
    getRecentProducts(x_API_PREPARE_ID: string, excludedSKU: string | undefined): Promise<ProductViewModelBase[]>;
}

export class ActivityClient extends ClientBase implements IActivityClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Retrieves products recently visited.
     * @param x_API_PREPARE_ID (Mandatory) Channel request id.
     * @param excludedSKU (optional) SKU to exclude.
     * @return Success
     */
    getRecentProducts(x_API_PREPARE_ID: string, excludedSKU: string | undefined): Promise<ProductViewModelBase[]> {
        let url_ = this.baseUrl + "/api/Activity/GetRecentProducts?";
        if (excludedSKU === null)
            throw new Error("The parameter 'excludedSKU' cannot be null.");
        else if (excludedSKU !== undefined)
            url_ += "excludedSKU=" + encodeURIComponent("" + excludedSKU) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-API-PREPARE-ID": x_API_PREPARE_ID !== undefined && x_API_PREPARE_ID !== null ? "" + x_API_PREPARE_ID : "",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRecentProducts(_response);
        });
    }

    protected processGetRecentProducts(response: Response): Promise<ProductViewModelBase[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductViewModelBase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductViewModelBase[]>(null as any);
    }
}

export interface IActivityLogClient {

    /**
     * Log product visit.
     * @param x_API_PREPARE_ID Channel request id.
     * @param body (optional) Request model.
     * @return Success
     */
    logProductVisit(x_API_PREPARE_ID: string, body: LogProductVisitRequestModel | undefined): Promise<void>;

    /**
     * Log catalog category visit.
     * @param x_API_PREPARE_ID Channel request id.
     * @param body (optional) Request model.
     * @return Success
     */
    logCatalogCategoryVisit(x_API_PREPARE_ID: string, body: LogCatalogCategoryVisitRequestModel | undefined): Promise<void>;

    /**
     * Log search.
     * @param x_API_PREPARE_ID Channel request id.
     * @param body (optional) Request model.
     * @return Success
     */
    logSearch(x_API_PREPARE_ID: string, body: LogSearchRequestModel | undefined): Promise<void>;
}

export class ActivityLogClient extends ClientBase implements IActivityLogClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Log product visit.
     * @param x_API_PREPARE_ID Channel request id.
     * @param body (optional) Request model.
     * @return Success
     */
    logProductVisit(x_API_PREPARE_ID: string, body: LogProductVisitRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ActivityLog/LogProductVisit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-API-PREPARE-ID": x_API_PREPARE_ID !== undefined && x_API_PREPARE_ID !== null ? "" + x_API_PREPARE_ID : "",
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogProductVisit(_response);
        });
    }

    protected processLogProductVisit(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Log catalog category visit.
     * @param x_API_PREPARE_ID Channel request id.
     * @param body (optional) Request model.
     * @return Success
     */
    logCatalogCategoryVisit(x_API_PREPARE_ID: string, body: LogCatalogCategoryVisitRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ActivityLog/LogCatalogCategoryVisit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-API-PREPARE-ID": x_API_PREPARE_ID !== undefined && x_API_PREPARE_ID !== null ? "" + x_API_PREPARE_ID : "",
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogCatalogCategoryVisit(_response);
        });
    }

    protected processLogCatalogCategoryVisit(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Log search.
     * @param x_API_PREPARE_ID Channel request id.
     * @param body (optional) Request model.
     * @return Success
     */
    logSearch(x_API_PREPARE_ID: string, body: LogSearchRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ActivityLog/LogSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-API-PREPARE-ID": x_API_PREPARE_ID !== undefined && x_API_PREPARE_ID !== null ? "" + x_API_PREPARE_ID : "",
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogSearch(_response);
        });
    }

    protected processLogSearch(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IASWPClient {

    /**
     * @return Success
     */
    getActiveApplicationMessagesByApplicationType(): Promise<ApplicationMessageResponse[]>;
}

export class ASWPClient extends ClientBase implements IASWPClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getActiveApplicationMessagesByApplicationType(): Promise<ApplicationMessageResponse[]> {
        let url_ = this.baseUrl + "/api/ASWP/GetActiveApplicationMessagesByApplicationTypeAsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetActiveApplicationMessagesByApplicationType(_response);
        });
    }

    protected processGetActiveApplicationMessagesByApplicationType(response: Response): Promise<ApplicationMessageResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicationMessageResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationMessageResponse[]>(null as any);
    }
}

export interface IBrandClient {

    /**
     * Retrieves a specific brand by URL short.
     * @param urlShort (Mandatory) URL short for the brand. Example: vw.
     * @return Success
     */
    brand(urlShort: string): Promise<BrandViewModel>;

    /**
     * Retrieves all brands.
     * @return Success
     */
    all(): Promise<BrandViewModel[]>;

    /**
     * Retrieves a specific brand by ID.
     * @return Success
     */
    byId(brandId: number): Promise<BrandViewModel>;
}

export class BrandClient extends ClientBase implements IBrandClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Retrieves a specific brand by URL short.
     * @param urlShort (Mandatory) URL short for the brand. Example: vw.
     * @return Success
     */
    brand(urlShort: string): Promise<BrandViewModel> {
        let url_ = this.baseUrl + "/api/Brand/{urlShort}";
        if (urlShort === undefined || urlShort === null)
            throw new Error("The parameter 'urlShort' must be defined.");
        url_ = url_.replace("{urlShort}", encodeURIComponent("" + urlShort));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBrand(_response);
        });
    }

    protected processBrand(response: Response): Promise<BrandViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BrandViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BrandViewModel>(null as any);
    }

    /**
     * Retrieves all brands.
     * @return Success
     */
    all(): Promise<BrandViewModel[]> {
        let url_ = this.baseUrl + "/api/Brand/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<BrandViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BrandViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BrandViewModel[]>(null as any);
    }

    /**
     * Retrieves a specific brand by ID.
     * @return Success
     */
    byId(brandId: number): Promise<BrandViewModel> {
        let url_ = this.baseUrl + "/api/Brand/by-id/{brandId}";
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined.");
        url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processById(_response);
        });
    }

    protected processById(response: Response): Promise<BrandViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BrandViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BrandViewModel>(null as any);
    }
}

export interface IBreadcrumbsClient {

    /**
     * Get category hierarchy.
     * @param productId Product id.
     * @param channelRequestId (optional) 
     * @return Success
     */
    byProductId(productId: number, channelRequestId: string | undefined): Promise<BreadcrumbsViewModel[]>;

    /**
     * Get category hierarchy.
     * @param categoryId (Required) Category id.
     * @return Success
     */
    byCategoryId(categoryId: number): Promise<BreadcrumbsViewModel[]>;
}

export class BreadcrumbsClient extends ClientBase implements IBreadcrumbsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get category hierarchy.
     * @param productId Product id.
     * @param channelRequestId (optional) 
     * @return Success
     */
    byProductId(productId: number, channelRequestId: string | undefined): Promise<BreadcrumbsViewModel[]> {
        let url_ = this.baseUrl + "/api/Breadcrumbs/byProductId/{productId}?";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        if (channelRequestId === null)
            throw new Error("The parameter 'channelRequestId' cannot be null.");
        else if (channelRequestId !== undefined)
            url_ += "channelRequestId=" + encodeURIComponent("" + channelRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processByProductId(_response);
        });
    }

    protected processByProductId(response: Response): Promise<BreadcrumbsViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BreadcrumbsViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BreadcrumbsViewModel[]>(null as any);
    }

    /**
     * Get category hierarchy.
     * @param categoryId (Required) Category id.
     * @return Success
     */
    byCategoryId(categoryId: number): Promise<BreadcrumbsViewModel[]> {
        let url_ = this.baseUrl + "/api/Breadcrumbs/byCategoryId/{categoryId}";
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processByCategoryId(_response);
        });
    }

    protected processByCategoryId(response: Response): Promise<BreadcrumbsViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BreadcrumbsViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BreadcrumbsViewModel[]>(null as any);
    }
}

export interface ICampaignCodeClient {

    /**
     * @param campaignCode (optional) 
     * @param dealerNumber (optional) 
     * @return Success
     */
    findCampaignCode(campaignCode: string | undefined, dealerNumber: string | undefined): Promise<FindCampaignCodeResponse>;
}

export class CampaignCodeClient extends ClientBase implements ICampaignCodeClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param campaignCode (optional) 
     * @param dealerNumber (optional) 
     * @return Success
     */
    findCampaignCode(campaignCode: string | undefined, dealerNumber: string | undefined): Promise<FindCampaignCodeResponse> {
        let url_ = this.baseUrl + "/api/CampaignCode/FindCampaignCode?";
        if (campaignCode === null)
            throw new Error("The parameter 'campaignCode' cannot be null.");
        else if (campaignCode !== undefined)
            url_ += "campaignCode=" + encodeURIComponent("" + campaignCode) + "&";
        if (dealerNumber === null)
            throw new Error("The parameter 'dealerNumber' cannot be null.");
        else if (dealerNumber !== undefined)
            url_ += "dealerNumber=" + encodeURIComponent("" + dealerNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFindCampaignCode(_response);
        });
    }

    protected processFindCampaignCode(response: Response): Promise<FindCampaignCodeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FindCampaignCodeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FindCampaignCodeResponse>(null as any);
    }
}

export interface ICatalogCategoryClient {

    /**
     * Retrieves catalog categories.
     * @param x_API_PREPARE_ID (optional) 
     * @return Success
     */
    catalogCategory(x_API_PREPARE_ID: string | undefined): Promise<CatalogCategoryViewModelBase[]>;

    /**
     * Retrieves catalog categories by ids.
     * @param ids (optional) 
     * @param x_API_PREPARE_ID (optional) 
     * @return Success
     */
    getCategoriesByIds(ids: number[] | undefined, x_API_PREPARE_ID: string | undefined): Promise<CatalogCategoryViewModelBase[]>;

    /**
     * Retrieves a specific catalog category.
     * @param x_API_PREPARE_ID (optional) 
     * @return Success
     */
    details(catalogCategoryId: number, x_API_PREPARE_ID: string | undefined): Promise<CatalogCategoryViewModel>;

    /**
     * Retrieves a specific catalog category by list.
     * @param x_API_PREPARE_ID (optional) 
     * @param body (optional) 
     * @return Success
     */
    getCatalogCategoriesByList(x_API_PREPARE_ID: string | undefined, body: KeyValueRequestModel[] | undefined): Promise<CatalogCategoryViewModelBase[]>;
}

export class CatalogCategoryClient extends ClientBase implements ICatalogCategoryClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Retrieves catalog categories.
     * @param x_API_PREPARE_ID (optional) 
     * @return Success
     */
    catalogCategory(x_API_PREPARE_ID: string | undefined): Promise<CatalogCategoryViewModelBase[]> {
        let url_ = this.baseUrl + "/api/CatalogCategory";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-API-PREPARE-ID": x_API_PREPARE_ID !== undefined && x_API_PREPARE_ID !== null ? "" + x_API_PREPARE_ID : "",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCatalogCategory(_response);
        });
    }

    protected processCatalogCategory(response: Response): Promise<CatalogCategoryViewModelBase[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CatalogCategoryViewModelBase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogCategoryViewModelBase[]>(null as any);
    }

    /**
     * Retrieves catalog categories by ids.
     * @param ids (optional) 
     * @param x_API_PREPARE_ID (optional) 
     * @return Success
     */
    getCategoriesByIds(ids: number[] | undefined, x_API_PREPARE_ID: string | undefined): Promise<CatalogCategoryViewModelBase[]> {
        let url_ = this.baseUrl + "/api/CatalogCategory/GetCategoriesByIds?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-API-PREPARE-ID": x_API_PREPARE_ID !== undefined && x_API_PREPARE_ID !== null ? "" + x_API_PREPARE_ID : "",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCategoriesByIds(_response);
        });
    }

    protected processGetCategoriesByIds(response: Response): Promise<CatalogCategoryViewModelBase[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CatalogCategoryViewModelBase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogCategoryViewModelBase[]>(null as any);
    }

    /**
     * Retrieves a specific catalog category.
     * @param x_API_PREPARE_ID (optional) 
     * @return Success
     */
    details(catalogCategoryId: number, x_API_PREPARE_ID: string | undefined): Promise<CatalogCategoryViewModel> {
        let url_ = this.baseUrl + "/api/CatalogCategory/details/{catalogCategoryId}";
        if (catalogCategoryId === undefined || catalogCategoryId === null)
            throw new Error("The parameter 'catalogCategoryId' must be defined.");
        url_ = url_.replace("{catalogCategoryId}", encodeURIComponent("" + catalogCategoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-API-PREPARE-ID": x_API_PREPARE_ID !== undefined && x_API_PREPARE_ID !== null ? "" + x_API_PREPARE_ID : "",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDetails(_response);
        });
    }

    protected processDetails(response: Response): Promise<CatalogCategoryViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CatalogCategoryViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogCategoryViewModel>(null as any);
    }

    /**
     * Retrieves a specific catalog category by list.
     * @param x_API_PREPARE_ID (optional) 
     * @param body (optional) 
     * @return Success
     */
    getCatalogCategoriesByList(x_API_PREPARE_ID: string | undefined, body: KeyValueRequestModel[] | undefined): Promise<CatalogCategoryViewModelBase[]> {
        let url_ = this.baseUrl + "/api/CatalogCategory/GetCatalogCategoriesByListAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-API-PREPARE-ID": x_API_PREPARE_ID !== undefined && x_API_PREPARE_ID !== null ? "" + x_API_PREPARE_ID : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogCategoriesByList(_response);
        });
    }

    protected processGetCatalogCategoriesByList(response: Response): Promise<CatalogCategoryViewModelBase[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CatalogCategoryViewModelBase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogCategoryViewModelBase[]>(null as any);
    }
}

export interface IChannelRequestClient {

    /**
     * Retrieves a channel request.
     * @param x_API_PREPARE_ID (optional) Channel request id.
     * @param shoppingCartId (optional) Shopping cart id.
     * @return Success
     */
    channelRequestGet(x_API_PREPARE_ID: string | undefined, shoppingCartId: string | undefined): Promise<ChannelRequestViewModel>;

    /**
     * Creates a channel request.
     * @param body (optional) Request model.
     * @return Success
     */
    channelRequestPost(body: CreateChannelRequestRequestModel | undefined): Promise<CreateChannelRequestResponseModel>;

    /**
     * Updates a channel request.
     * @param body (optional) Request model.
     * @return Success
     */
    update(body: UpdateChannelRequestRequestModel | undefined): Promise<UpdateChannelRequestResponseModel>;
}

export class ChannelRequestClient extends ClientBase implements IChannelRequestClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Retrieves a channel request.
     * @param x_API_PREPARE_ID (optional) Channel request id.
     * @param shoppingCartId (optional) Shopping cart id.
     * @return Success
     */
    channelRequestGet(x_API_PREPARE_ID: string | undefined, shoppingCartId: string | undefined): Promise<ChannelRequestViewModel> {
        let url_ = this.baseUrl + "/api/ChannelRequest?";
        if (shoppingCartId === null)
            throw new Error("The parameter 'shoppingCartId' cannot be null.");
        else if (shoppingCartId !== undefined)
            url_ += "shoppingCartId=" + encodeURIComponent("" + shoppingCartId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-API-PREPARE-ID": x_API_PREPARE_ID !== undefined && x_API_PREPARE_ID !== null ? "" + x_API_PREPARE_ID : "",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChannelRequestGet(_response);
        });
    }

    protected processChannelRequestGet(response: Response): Promise<ChannelRequestViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChannelRequestViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChannelRequestViewModel>(null as any);
    }

    /**
     * Creates a channel request.
     * @param body (optional) Request model.
     * @return Success
     */
    channelRequestPost(body: CreateChannelRequestRequestModel | undefined): Promise<CreateChannelRequestResponseModel> {
        let url_ = this.baseUrl + "/api/ChannelRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChannelRequestPost(_response);
        });
    }

    protected processChannelRequestPost(response: Response): Promise<CreateChannelRequestResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateChannelRequestResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateChannelRequestResponseModel>(null as any);
    }

    /**
     * Updates a channel request.
     * @param body (optional) Request model.
     * @return Success
     */
    update(body: UpdateChannelRequestRequestModel | undefined): Promise<UpdateChannelRequestResponseModel> {
        let url_ = this.baseUrl + "/api/ChannelRequest/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<UpdateChannelRequestResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateChannelRequestResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateChannelRequestResponseModel>(null as any);
    }
}

export interface IChassiClient {

    /**
     * Retrieves chassi by reg nr.
     * @param body (optional) Request model.
     * @return Success
     */
    chassi(body: SearchVehicleRequestModel | undefined): Promise<ChassiViewModel>;
}

export class ChassiClient extends ClientBase implements IChassiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Retrieves chassi by reg nr.
     * @param body (optional) Request model.
     * @return Success
     */
    chassi(body: SearchVehicleRequestModel | undefined): Promise<ChassiViewModel> {
        let url_ = this.baseUrl + "/api/Chassi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChassi(_response);
        });
    }

    protected processChassi(response: Response): Promise<ChassiViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChassiViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChassiViewModel>(null as any);
    }
}

export interface IDealerClient {

    /**
     * Retrieves dealers.
     * @param body (optional) Request model.
     * @return Success
     */
    dealer(body: SearchDealerRequestModel | undefined): Promise<DealerViewModel[]>;
}

export class DealerClient extends ClientBase implements IDealerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Retrieves dealers.
     * @param body (optional) Request model.
     * @return Success
     */
    dealer(body: SearchDealerRequestModel | undefined): Promise<DealerViewModel[]> {
        let url_ = this.baseUrl + "/api/Dealer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDealer(_response);
        });
    }

    protected processDealer(response: Response): Promise<DealerViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DealerViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DealerViewModel[]>(null as any);
    }
}

export interface IFileClient {

    /**
     * Retrieves file.
     * @return Success
     */
    file(filename: string): Promise<FileResponse>;
}

export class FileClient extends ClientBase implements IFileClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Retrieves file.
     * @return Success
     */
    file(filename: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/File/{filename}";
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFile(_response);
        });
    }

    protected processFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = NotFoundResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IMenuClient {

    /**
     * Retrieves the menu for a specific brand.
     * @param x_API_PREPARE_ID Channel request id.
     * @param brandId (optional) (Mandatory) Id of Brand. Example: 1
     * @return Success
     */
    menu(x_API_PREPARE_ID: string, brandId: number | undefined): Promise<MenuLinkViewModel[]>;
}

export class MenuClient extends ClientBase implements IMenuClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Retrieves the menu for a specific brand.
     * @param x_API_PREPARE_ID Channel request id.
     * @param brandId (optional) (Mandatory) Id of Brand. Example: 1
     * @return Success
     */
    menu(x_API_PREPARE_ID: string, brandId: number | undefined): Promise<MenuLinkViewModel[]> {
        let url_ = this.baseUrl + "/api/Menu?";
        if (brandId === null)
            throw new Error("The parameter 'brandId' cannot be null.");
        else if (brandId !== undefined)
            url_ += "brandId=" + encodeURIComponent("" + brandId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-API-PREPARE-ID": x_API_PREPARE_ID !== undefined && x_API_PREPARE_ID !== null ? "" + x_API_PREPARE_ID : "",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMenu(_response);
        });
    }

    protected processMenu(response: Response): Promise<MenuLinkViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MenuLinkViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MenuLinkViewModel[]>(null as any);
    }
}

export interface IModelClient {

    /**
     * Get model groups.
     * @param brandId (optional) (Mandatory). Brand ID.
     * @return Success
     */
    groups(brandId: number | undefined): Promise<ModelGroupViewModel[]>;

    /**
     * Get unique years by model group.
     * @param brandId (optional) (Mandatory). Brand ID.
     * @param modelGroupId (optional) (Mandatory). Model group ID.
     * @return Success
     */
    years(brandId: number | undefined, modelGroupId: number | undefined): Promise<number[]>;

    /**
     * Get models by model group id and year.
     * @param brandId (optional) (Mandatory). Brand ID.
     * @param year (optional) (Mandatory). Year. Example: 2018.
     * @param modelGroupID (optional) (Mandatory). Model group ID.
     * @return Success
     */
    model(brandId: number | undefined, year: number | undefined, modelGroupID: number | undefined): Promise<ModelViewModel[]>;

    /**
     * Get model by model code and year.
     * @param brandId (optional) (Mandatory). Brand ID.
     * @param modelCode (optional) (Mandatory). Model code.
     * @param year (optional) (Mandatory). Year. Example: 2018.
     * @return Success
     */
    code(brandId: number | undefined, modelCode: string | undefined, year: number | undefined): Promise<ModelViewModel>;
}

export class ModelClient extends ClientBase implements IModelClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get model groups.
     * @param brandId (optional) (Mandatory). Brand ID.
     * @return Success
     */
    groups(brandId: number | undefined): Promise<ModelGroupViewModel[]> {
        let url_ = this.baseUrl + "/api/Model/groups?";
        if (brandId === null)
            throw new Error("The parameter 'brandId' cannot be null.");
        else if (brandId !== undefined)
            url_ += "brandId=" + encodeURIComponent("" + brandId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGroups(_response);
        });
    }

    protected processGroups(response: Response): Promise<ModelGroupViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ModelGroupViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelGroupViewModel[]>(null as any);
    }

    /**
     * Get unique years by model group.
     * @param brandId (optional) (Mandatory). Brand ID.
     * @param modelGroupId (optional) (Mandatory). Model group ID.
     * @return Success
     */
    years(brandId: number | undefined, modelGroupId: number | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/api/Model/years?";
        if (brandId === null)
            throw new Error("The parameter 'brandId' cannot be null.");
        else if (brandId !== undefined)
            url_ += "brandId=" + encodeURIComponent("" + brandId) + "&";
        if (modelGroupId === null)
            throw new Error("The parameter 'modelGroupId' cannot be null.");
        else if (modelGroupId !== undefined)
            url_ += "modelGroupId=" + encodeURIComponent("" + modelGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processYears(_response);
        });
    }

    protected processYears(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * Get models by model group id and year.
     * @param brandId (optional) (Mandatory). Brand ID.
     * @param year (optional) (Mandatory). Year. Example: 2018.
     * @param modelGroupID (optional) (Mandatory). Model group ID.
     * @return Success
     */
    model(brandId: number | undefined, year: number | undefined, modelGroupID: number | undefined): Promise<ModelViewModel[]> {
        let url_ = this.baseUrl + "/api/Model?";
        if (brandId === null)
            throw new Error("The parameter 'brandId' cannot be null.");
        else if (brandId !== undefined)
            url_ += "brandId=" + encodeURIComponent("" + brandId) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (modelGroupID === null)
            throw new Error("The parameter 'modelGroupID' cannot be null.");
        else if (modelGroupID !== undefined)
            url_ += "modelGroupID=" + encodeURIComponent("" + modelGroupID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processModel(_response);
        });
    }

    protected processModel(response: Response): Promise<ModelViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ModelViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelViewModel[]>(null as any);
    }

    /**
     * Get model by model code and year.
     * @param brandId (optional) (Mandatory). Brand ID.
     * @param modelCode (optional) (Mandatory). Model code.
     * @param year (optional) (Mandatory). Year. Example: 2018.
     * @return Success
     */
    code(brandId: number | undefined, modelCode: string | undefined, year: number | undefined): Promise<ModelViewModel> {
        let url_ = this.baseUrl + "/api/Model/code?";
        if (brandId === null)
            throw new Error("The parameter 'brandId' cannot be null.");
        else if (brandId !== undefined)
            url_ += "brandId=" + encodeURIComponent("" + brandId) + "&";
        if (modelCode === null)
            throw new Error("The parameter 'modelCode' cannot be null.");
        else if (modelCode !== undefined)
            url_ += "modelCode=" + encodeURIComponent("" + modelCode) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCode(_response);
        });
    }

    protected processCode(response: Response): Promise<ModelViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModelViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelViewModel>(null as any);
    }
}

export interface IOrderClient {

    /**
     * Creates an order.
     * @param x_API_PREPARE_ID Channel request id.
     * @param body (optional) Request model.
     * @return Success
     */
    create(x_API_PREPARE_ID: string, body: CreateOrderRequestModel | undefined): Promise<CreateOrderResponseModel>;

    /**
     * Retrieves order number for an order by shopping cart ID.
     * @param shoppingCartId (Mandatory) Shopping cart ID.
     * @return Success
     */
    orderNr(shoppingCartId: string): Promise<number>;
}

export class OrderClient extends ClientBase implements IOrderClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Creates an order.
     * @param x_API_PREPARE_ID Channel request id.
     * @param body (optional) Request model.
     * @return Success
     */
    create(x_API_PREPARE_ID: string, body: CreateOrderRequestModel | undefined): Promise<CreateOrderResponseModel> {
        let url_ = this.baseUrl + "/api/Order/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-API-PREPARE-ID": x_API_PREPARE_ID !== undefined && x_API_PREPARE_ID !== null ? "" + x_API_PREPARE_ID : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<CreateOrderResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrderResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateOrderResponseModel>(null as any);
    }

    /**
     * Retrieves order number for an order by shopping cart ID.
     * @param shoppingCartId (Mandatory) Shopping cart ID.
     * @return Success
     */
    orderNr(shoppingCartId: string): Promise<number> {
        let url_ = this.baseUrl + "/api/Order/{shoppingCartId}/orderNr";
        if (shoppingCartId === undefined || shoppingCartId === null)
            throw new Error("The parameter 'shoppingCartId' must be defined.");
        url_ = url_.replace("{shoppingCartId}", encodeURIComponent("" + shoppingCartId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processOrderNr(_response);
        });
    }

    protected processOrderNr(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface IPageClient {

    /**
     * Retrieves a specific page for a specific brand.
     * @param brandId (optional) (Mandatory) Brand ID. Example: 1.
     * @param pageType (optional) (Mandatory) Page type. Example: Start.
     * @return Success
     */
    page(brandId: number | undefined, pageType: PageTypeEnum | undefined): Promise<PageViewModel>;
}

export class PageClient extends ClientBase implements IPageClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Retrieves a specific page for a specific brand.
     * @param brandId (optional) (Mandatory) Brand ID. Example: 1.
     * @param pageType (optional) (Mandatory) Page type. Example: Start.
     * @return Success
     */
    page(brandId: number | undefined, pageType: PageTypeEnum | undefined): Promise<PageViewModel> {
        let url_ = this.baseUrl + "/api/Page?";
        if (brandId === null)
            throw new Error("The parameter 'brandId' cannot be null.");
        else if (brandId !== undefined)
            url_ += "brandId=" + encodeURIComponent("" + brandId) + "&";
        if (pageType === null)
            throw new Error("The parameter 'pageType' cannot be null.");
        else if (pageType !== undefined)
            url_ += "pageType=" + encodeURIComponent("" + pageType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: Response): Promise<PageViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PageViewModel>(null as any);
    }
}

export interface IPassingControlClient {

    /**
     * Passing control by product id
     * @param productId Product id. (Mandatory).
     * @param x_API_PREPARE_ID (Mandatory). Channel request id.
     * @return Success
     */
    product(productId: number, x_API_PREPARE_ID: string): Promise<boolean>;

    /**
     * Passing control by category id
     * @param categoryId Category id. (Mandatory).
     * @param x_API_PREPARE_ID (Mandatory). Channel request id.
     * @return Success
     */
    category(categoryId: number, x_API_PREPARE_ID: string): Promise<boolean>;
}

export class PassingControlClient extends ClientBase implements IPassingControlClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Passing control by product id
     * @param productId Product id. (Mandatory).
     * @param x_API_PREPARE_ID (Mandatory). Channel request id.
     * @return Success
     */
    product(productId: number, x_API_PREPARE_ID: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/PassingControl/product/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-API-PREPARE-ID": x_API_PREPARE_ID !== undefined && x_API_PREPARE_ID !== null ? "" + x_API_PREPARE_ID : "",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProduct(_response);
        });
    }

    protected processProduct(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Passing control by category id
     * @param categoryId Category id. (Mandatory).
     * @param x_API_PREPARE_ID (Mandatory). Channel request id.
     * @return Success
     */
    category(categoryId: number, x_API_PREPARE_ID: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/PassingControl/category/{categoryId}";
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-API-PREPARE-ID": x_API_PREPARE_ID !== undefined && x_API_PREPARE_ID !== null ? "" + x_API_PREPARE_ID : "",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCategory(_response);
        });
    }

    protected processCategory(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IProductClient {

    /**
     * Retrieves a specific product.
     * @param sku (optional) (Mandatory) SKU. Example: 000051884P.
     * @param x_API_PREPARE_ID (Mandatory) Channel request ID.
     * @return Success
     */
    details(sku: string | undefined, x_API_PREPARE_ID: string): Promise<ProductViewModel>;

    /**
     * Retrieves products by productIDs.
     * @param x_API_PREPARE_ID (Mandatory) Channel request ID.
     * @param body (optional) Product IDs.
     * @return Success
     * @deprecated
     */
    product(x_API_PREPARE_ID: string, body: number[] | undefined): Promise<ProductViewModel[]>;

    /**
     * Retrieves products by productIDs.
     * @param x_API_PREPARE_ID (Mandatory) Channel request ID.
     * @param body (optional) Product IDs.
     * @return Success
     */
    base(x_API_PREPARE_ID: string, body: number[] | undefined): Promise<ProductViewModelBase[]>;

    /**
     * Retrieves popular products.
     * @param x_API_PREPARE_ID (Mandatory) Channel request ID.
     * @param categoryId (optional) Category ID.
     * @return Success
     */
    popular(x_API_PREPARE_ID: string, categoryId: number | undefined): Promise<ProductViewModelBase[]>;

    /**
     * Retrieves up sales for a specific product.
     * @param sku (optional) (Mandatory) SKU. Example: 000051884P.
     * @param x_API_PREPARE_ID (Mandatory) Channel request ID.
     * @return Success
     */
    upSales(sku: string | undefined, x_API_PREPARE_ID: string): Promise<ProductUpSaleViewModel[]>;
}

export class ProductClient extends ClientBase implements IProductClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Retrieves a specific product.
     * @param sku (optional) (Mandatory) SKU. Example: 000051884P.
     * @param x_API_PREPARE_ID (Mandatory) Channel request ID.
     * @return Success
     */
    details(sku: string | undefined, x_API_PREPARE_ID: string): Promise<ProductViewModel> {
        let url_ = this.baseUrl + "/api/Product/details?";
        if (sku === null)
            throw new Error("The parameter 'sku' cannot be null.");
        else if (sku !== undefined)
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-API-PREPARE-ID": x_API_PREPARE_ID !== undefined && x_API_PREPARE_ID !== null ? "" + x_API_PREPARE_ID : "",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDetails(_response);
        });
    }

    protected processDetails(response: Response): Promise<ProductViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductViewModel>(null as any);
    }

    /**
     * Retrieves products by productIDs.
     * @param x_API_PREPARE_ID (Mandatory) Channel request ID.
     * @param body (optional) Product IDs.
     * @return Success
     * @deprecated
     */
    product(x_API_PREPARE_ID: string, body: number[] | undefined): Promise<ProductViewModel[]> {
        let url_ = this.baseUrl + "/api/Product";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-API-PREPARE-ID": x_API_PREPARE_ID !== undefined && x_API_PREPARE_ID !== null ? "" + x_API_PREPARE_ID : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProduct(_response);
        });
    }

    protected processProduct(response: Response): Promise<ProductViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductViewModel[]>(null as any);
    }

    /**
     * Retrieves products by productIDs.
     * @param x_API_PREPARE_ID (Mandatory) Channel request ID.
     * @param body (optional) Product IDs.
     * @return Success
     */
    base(x_API_PREPARE_ID: string, body: number[] | undefined): Promise<ProductViewModelBase[]> {
        let url_ = this.baseUrl + "/api/Product/base";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-API-PREPARE-ID": x_API_PREPARE_ID !== undefined && x_API_PREPARE_ID !== null ? "" + x_API_PREPARE_ID : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBase(_response);
        });
    }

    protected processBase(response: Response): Promise<ProductViewModelBase[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductViewModelBase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductViewModelBase[]>(null as any);
    }

    /**
     * Retrieves popular products.
     * @param x_API_PREPARE_ID (Mandatory) Channel request ID.
     * @param categoryId (optional) Category ID.
     * @return Success
     */
    popular(x_API_PREPARE_ID: string, categoryId: number | undefined): Promise<ProductViewModelBase[]> {
        let url_ = this.baseUrl + "/api/Product/popular?";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-API-PREPARE-ID": x_API_PREPARE_ID !== undefined && x_API_PREPARE_ID !== null ? "" + x_API_PREPARE_ID : "",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPopular(_response);
        });
    }

    protected processPopular(response: Response): Promise<ProductViewModelBase[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductViewModelBase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductViewModelBase[]>(null as any);
    }

    /**
     * Retrieves up sales for a specific product.
     * @param sku (optional) (Mandatory) SKU. Example: 000051884P.
     * @param x_API_PREPARE_ID (Mandatory) Channel request ID.
     * @return Success
     */
    upSales(sku: string | undefined, x_API_PREPARE_ID: string): Promise<ProductUpSaleViewModel[]> {
        let url_ = this.baseUrl + "/api/Product/upSales?";
        if (sku === null)
            throw new Error("The parameter 'sku' cannot be null.");
        else if (sku !== undefined)
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-API-PREPARE-ID": x_API_PREPARE_ID !== undefined && x_API_PREPARE_ID !== null ? "" + x_API_PREPARE_ID : "",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpSales(_response);
        });
    }

    protected processUpSales(response: Response): Promise<ProductUpSaleViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductUpSaleViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductUpSaleViewModel[]>(null as any);
    }
}

export interface ISearchClient {

    /**
     * Retrieves products and categories by query.
     * @param x_API_PREPARE_ID ChannelRequestId
     * @param body (optional) Search query model
     * @return Success
     */
    query(x_API_PREPARE_ID: string, body: SearchQueryModel | undefined): Promise<SearchResultModel>;
}

export class SearchClient extends ClientBase implements ISearchClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Retrieves products and categories by query.
     * @param x_API_PREPARE_ID ChannelRequestId
     * @param body (optional) Search query model
     * @return Success
     */
    query(x_API_PREPARE_ID: string, body: SearchQueryModel | undefined): Promise<SearchResultModel> {
        let url_ = this.baseUrl + "/api/Search/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-API-PREPARE-ID": x_API_PREPARE_ID !== undefined && x_API_PREPARE_ID !== null ? "" + x_API_PREPARE_ID : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: Response): Promise<SearchResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchResultModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchResultModel>(null as any);
    }
}

export interface ISettingClient {

    /**
     * Retrieves application settings.
     * @param channel (optional) (Optional) Channel.
     * @return Success
     */
    setting(channel: ChannelEnum | undefined): Promise<SettingViewModel[]>;
}

export class SettingClient extends ClientBase implements ISettingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Retrieves application settings.
     * @param channel (optional) (Optional) Channel.
     * @return Success
     */
    setting(channel: ChannelEnum | undefined): Promise<SettingViewModel[]> {
        let url_ = this.baseUrl + "/api/Setting?";
        if (channel === null)
            throw new Error("The parameter 'channel' cannot be null.");
        else if (channel !== undefined)
            url_ += "channel=" + encodeURIComponent("" + channel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetting(_response);
        });
    }

    protected processSetting(response: Response): Promise<SettingViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SettingViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SettingViewModel[]>(null as any);
    }
}

export interface IShoppingCartClient {

    /**
     * Retrieves a specific shopping cart.
     * @param shoppingCartId (Mandatory) Shopping Cart ID.
     * @return Success
     */
    shoppingCart(shoppingCartId: string): Promise<ShoppingCartViewModel>;

    /**
     * Retrieves a specific shopping cart id by channel request id.
     * @param channelRequestId (optional) (Mandatory) Shopping Cart ID.
     * @return Success
     */
    getShoppingCartIdByChannelRequestId(channelRequestId: string | undefined): Promise<string>;

    /**
     * Creates a shopping cart.
     * @param body (optional) (Mandatory) Request model.
     * @return Success
     */
    create(body: CreateShoppingCartRequestModel | undefined): Promise<ShoppingCartViewModel>;

    /**
     * Clears a specific shopping cart of shopping cart items.
     * @param shoppingCartId (Mandatory) Shopping Cart ID.
     * @return Success
     */
    clear(shoppingCartId: string): Promise<void>;

    /**
     * Updates vehicle and/or products in the shopping cart.
     * @param body (optional) Request model.
     * @return Success
     */
    update(body: UpdateShoppingCartRequestModel | undefined): Promise<ShoppingCartViewModel>;

    /**
     * Verifies a shopping cart.
     * @param body (optional) Request model.
     * @return Success
     */
    verify(body: VerifyShoppingCartRequestModel | undefined): Promise<ProductExceptionResponseModel[]>;
}

export class ShoppingCartClient extends ClientBase implements IShoppingCartClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Retrieves a specific shopping cart.
     * @param shoppingCartId (Mandatory) Shopping Cart ID.
     * @return Success
     */
    shoppingCart(shoppingCartId: string): Promise<ShoppingCartViewModel> {
        let url_ = this.baseUrl + "/api/ShoppingCart/{shoppingCartId}";
        if (shoppingCartId === undefined || shoppingCartId === null)
            throw new Error("The parameter 'shoppingCartId' must be defined.");
        url_ = url_.replace("{shoppingCartId}", encodeURIComponent("" + shoppingCartId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processShoppingCart(_response);
        });
    }

    protected processShoppingCart(response: Response): Promise<ShoppingCartViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShoppingCartViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShoppingCartViewModel>(null as any);
    }

    /**
     * Retrieves a specific shopping cart id by channel request id.
     * @param channelRequestId (optional) (Mandatory) Shopping Cart ID.
     * @return Success
     */
    getShoppingCartIdByChannelRequestId(channelRequestId: string | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/ShoppingCart/GetShoppingCartIdByChannelRequestId?";
        if (channelRequestId === null)
            throw new Error("The parameter 'channelRequestId' cannot be null.");
        else if (channelRequestId !== undefined)
            url_ += "channelRequestId=" + encodeURIComponent("" + channelRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetShoppingCartIdByChannelRequestId(_response);
        });
    }

    protected processGetShoppingCartIdByChannelRequestId(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Creates a shopping cart.
     * @param body (optional) (Mandatory) Request model.
     * @return Success
     */
    create(body: CreateShoppingCartRequestModel | undefined): Promise<ShoppingCartViewModel> {
        let url_ = this.baseUrl + "/api/ShoppingCart/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ShoppingCartViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShoppingCartViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShoppingCartViewModel>(null as any);
    }

    /**
     * Clears a specific shopping cart of shopping cart items.
     * @param shoppingCartId (Mandatory) Shopping Cart ID.
     * @return Success
     */
    clear(shoppingCartId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/ShoppingCart/{shoppingCartId}/clear";
        if (shoppingCartId === undefined || shoppingCartId === null)
            throw new Error("The parameter 'shoppingCartId' must be defined.");
        url_ = url_.replace("{shoppingCartId}", encodeURIComponent("" + shoppingCartId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processClear(_response);
        });
    }

    protected processClear(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Updates vehicle and/or products in the shopping cart.
     * @param body (optional) Request model.
     * @return Success
     */
    update(body: UpdateShoppingCartRequestModel | undefined): Promise<ShoppingCartViewModel> {
        let url_ = this.baseUrl + "/api/ShoppingCart/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ShoppingCartViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShoppingCartViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShoppingCartViewModel>(null as any);
    }

    /**
     * Verifies a shopping cart.
     * @param body (optional) Request model.
     * @return Success
     */
    verify(body: VerifyShoppingCartRequestModel | undefined): Promise<ProductExceptionResponseModel[]> {
        let url_ = this.baseUrl + "/api/ShoppingCart/verify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVerify(_response);
        });
    }

    protected processVerify(response: Response): Promise<ProductExceptionResponseModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductExceptionResponseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductExceptionResponseModel[]>(null as any);
    }
}

/** Address request model. */
export class AddressRequestModel implements IAddressRequestModel {
    /** (Mandatory). Address1. */
    address1!: string;
    /** Address. */
    address2?: string | undefined;
    /** (Mandatory). Postal code. */
    postalCode!: string;
    /** (Mandatory). City. */
    city!: string;

    constructor(data?: IAddressRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): AddressRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddressRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        return data;
    }
}

/** Address request model. */
export interface IAddressRequestModel {
    /** (Mandatory). Address1. */
    address1: string;
    /** Address. */
    address2?: string | undefined;
    /** (Mandatory). Postal code. */
    postalCode: string;
    /** (Mandatory). City. */
    city: string;
}

export class AddressViewModel implements IAddressViewModel {
    address1?: string | undefined;
    address2?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;

    constructor(data?: IAddressViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): AddressViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddressViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        return data;
    }
}

export interface IAddressViewModel {
    address1?: string | undefined;
    address2?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
}

export class ApiError implements IApiError {
    message?: string | undefined;
    isError?: boolean;
    detail?: string | undefined;

    constructor(data?: IApiError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.isError = _data["isError"];
            this.detail = _data["detail"];
        }
    }

    static fromJS(data: any): ApiError {
        data = typeof data === 'object' ? data : {};
        let result = new ApiError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["isError"] = this.isError;
        data["detail"] = this.detail;
        return data;
    }
}

export interface IApiError {
    message?: string | undefined;
    isError?: boolean;
    detail?: string | undefined;
}

export class ApplicationMessageResponse implements IApplicationMessageResponse {
    applicationMessageId?: number;
    applicationTypeId?: ApplicationTypeEnum;
    applicationMessageTypeId?: ApplicationMessageTypeEnum;
    isActive?: boolean;
    message?: string | undefined;

    constructor(data?: IApplicationMessageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationMessageId = _data["applicationMessageId"];
            this.applicationTypeId = _data["applicationTypeId"];
            this.applicationMessageTypeId = _data["applicationMessageTypeId"];
            this.isActive = _data["isActive"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ApplicationMessageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationMessageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationMessageId"] = this.applicationMessageId;
        data["applicationTypeId"] = this.applicationTypeId;
        data["applicationMessageTypeId"] = this.applicationMessageTypeId;
        data["isActive"] = this.isActive;
        data["message"] = this.message;
        return data;
    }
}

export interface IApplicationMessageResponse {
    applicationMessageId?: number;
    applicationTypeId?: ApplicationTypeEnum;
    applicationMessageTypeId?: ApplicationMessageTypeEnum;
    isActive?: boolean;
    message?: string | undefined;
}

export enum ApplicationMessageTypeEnum {
    Info = "Info",
    Warning = "Warning",
    Danger = "Danger",
}

export enum ApplicationTypeEnum {
    TBO = "TBO",
    VBO = "VBO",
}

export class BrandViewModel implements IBrandViewModel {
    brandId?: number;
    url?: string | undefined;
    urlShort?: string | undefined;
    displayName?: string | undefined;
    brandCode?: string | undefined;
    brandCardURL?: string | undefined;

    constructor(data?: IBrandViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brandId = _data["brandId"];
            this.url = _data["url"];
            this.urlShort = _data["urlShort"];
            this.displayName = _data["displayName"];
            this.brandCode = _data["brandCode"];
            this.brandCardURL = _data["brandCardURL"];
        }
    }

    static fromJS(data: any): BrandViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BrandViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brandId"] = this.brandId;
        data["url"] = this.url;
        data["urlShort"] = this.urlShort;
        data["displayName"] = this.displayName;
        data["brandCode"] = this.brandCode;
        data["brandCardURL"] = this.brandCardURL;
        return data;
    }
}

export interface IBrandViewModel {
    brandId?: number;
    url?: string | undefined;
    urlShort?: string | undefined;
    displayName?: string | undefined;
    brandCode?: string | undefined;
    brandCardURL?: string | undefined;
}

export class BreadcrumbsViewModel implements IBreadcrumbsViewModel {
    name?: string | undefined;
    id?: number;
    parentId?: number | undefined;

    constructor(data?: IBreadcrumbsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): BreadcrumbsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BreadcrumbsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface IBreadcrumbsViewModel {
    name?: string | undefined;
    id?: number;
    parentId?: number | undefined;
}

export class CampaignCodeResponse implements ICampaignCodeResponse {
    campaignCodeId?: number;
    name?: string | undefined;
    description?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
    discountType?: DiscountTypeEnum;
    discount?: number;
    isValidForCampaignProducts?: boolean;

    constructor(data?: ICampaignCodeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campaignCodeId = _data["campaignCodeId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            this.discountType = _data["discountType"];
            this.discount = _data["discount"];
            this.isValidForCampaignProducts = _data["isValidForCampaignProducts"];
        }
    }

    static fromJS(data: any): CampaignCodeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignCodeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignCodeId"] = this.campaignCodeId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["discountType"] = this.discountType;
        data["discount"] = this.discount;
        data["isValidForCampaignProducts"] = this.isValidForCampaignProducts;
        return data;
    }
}

export interface ICampaignCodeResponse {
    campaignCodeId?: number;
    name?: string | undefined;
    description?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
    discountType?: DiscountTypeEnum;
    discount?: number;
    isValidForCampaignProducts?: boolean;
}

export class CatalogCategoryViewModel implements ICatalogCategoryViewModel {
    catalogCategoryId?: number;
    parentId?: number | undefined;
    displayName?: string | undefined;
    sequence?: number | undefined;
    children?: CatalogCategoryViewModel[] | undefined;

    constructor(data?: ICatalogCategoryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.catalogCategoryId = _data["catalogCategoryId"];
            this.parentId = _data["parentId"];
            this.displayName = _data["displayName"];
            this.sequence = _data["sequence"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(CatalogCategoryViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CatalogCategoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogCategoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["catalogCategoryId"] = this.catalogCategoryId;
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        data["sequence"] = this.sequence;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICatalogCategoryViewModel {
    catalogCategoryId?: number;
    parentId?: number | undefined;
    displayName?: string | undefined;
    sequence?: number | undefined;
    children?: CatalogCategoryViewModel[] | undefined;
}

export class CatalogCategoryViewModelBase implements ICatalogCategoryViewModelBase {
    catalogCategoryId?: number;
    parentId?: number | undefined;
    displayName?: string | undefined;
    sequence?: number | undefined;

    constructor(data?: ICatalogCategoryViewModelBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.catalogCategoryId = _data["catalogCategoryId"];
            this.parentId = _data["parentId"];
            this.displayName = _data["displayName"];
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): CatalogCategoryViewModelBase {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogCategoryViewModelBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["catalogCategoryId"] = this.catalogCategoryId;
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        data["sequence"] = this.sequence;
        return data;
    }
}

export interface ICatalogCategoryViewModelBase {
    catalogCategoryId?: number;
    parentId?: number | undefined;
    displayName?: string | undefined;
    sequence?: number | undefined;
}

export enum ChannelEnum {
    TBO = "TBO",
    SAMS = "SAMS",
    Internal = "Internal",
}

export class ChannelRequestViewModel implements IChannelRequestViewModel {
    channelRequestId?: string;
    channelId?: number;
    dealerId?: number | undefined;
    expires?: Date;
    prepare?: boolean;
    externalSystemReference?: string | undefined;
    parties?: PartyViewModel[] | undefined;
    shoppingCart?: ShoppingCartViewModel;
    setup?: SetupViewModel[] | undefined;

    constructor(data?: IChannelRequestViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelRequestId = _data["channelRequestId"];
            this.channelId = _data["channelId"];
            this.dealerId = _data["dealerId"];
            this.expires = _data["expires"] ? new Date(_data["expires"].toString()) : <any>undefined;
            this.prepare = _data["prepare"];
            this.externalSystemReference = _data["externalSystemReference"];
            if (Array.isArray(_data["parties"])) {
                this.parties = [] as any;
                for (let item of _data["parties"])
                    this.parties!.push(PartyViewModel.fromJS(item));
            }
            this.shoppingCart = _data["shoppingCart"] ? ShoppingCartViewModel.fromJS(_data["shoppingCart"]) : <any>undefined;
            if (Array.isArray(_data["setup"])) {
                this.setup = [] as any;
                for (let item of _data["setup"])
                    this.setup!.push(SetupViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChannelRequestViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelRequestViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelRequestId"] = this.channelRequestId;
        data["channelId"] = this.channelId;
        data["dealerId"] = this.dealerId;
        data["expires"] = this.expires ? this.expires.toISOString() : <any>undefined;
        data["prepare"] = this.prepare;
        data["externalSystemReference"] = this.externalSystemReference;
        if (Array.isArray(this.parties)) {
            data["parties"] = [];
            for (let item of this.parties)
                data["parties"].push(item.toJSON());
        }
        data["shoppingCart"] = this.shoppingCart ? this.shoppingCart.toJSON() : <any>undefined;
        if (Array.isArray(this.setup)) {
            data["setup"] = [];
            for (let item of this.setup)
                data["setup"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChannelRequestViewModel {
    channelRequestId?: string;
    channelId?: number;
    dealerId?: number | undefined;
    expires?: Date;
    prepare?: boolean;
    externalSystemReference?: string | undefined;
    parties?: PartyViewModel[] | undefined;
    shoppingCart?: ShoppingCartViewModel;
    setup?: SetupViewModel[] | undefined;
}

export class ChassiViewModel implements IChassiViewModel {
    registrationNumber?: string | undefined;
    modelCode?: string | undefined;
    year?: number;
    chassiNumber17?: string | undefined;
    brand?: BrandViewModel;
    specialBrandCode?: string | undefined;
    specialBrand?: BrandViewModel;

    constructor(data?: IChassiViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registrationNumber = _data["registrationNumber"];
            this.modelCode = _data["modelCode"];
            this.year = _data["year"];
            this.chassiNumber17 = _data["chassiNumber17"];
            this.brand = _data["brand"] ? BrandViewModel.fromJS(_data["brand"]) : <any>undefined;
            this.specialBrandCode = _data["specialBrandCode"];
            this.specialBrand = _data["specialBrand"] ? BrandViewModel.fromJS(_data["specialBrand"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChassiViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChassiViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationNumber"] = this.registrationNumber;
        data["modelCode"] = this.modelCode;
        data["year"] = this.year;
        data["chassiNumber17"] = this.chassiNumber17;
        data["brand"] = this.brand ? this.brand.toJSON() : <any>undefined;
        data["specialBrandCode"] = this.specialBrandCode;
        data["specialBrand"] = this.specialBrand ? this.specialBrand.toJSON() : <any>undefined;
        return data;
    }
}

export interface IChassiViewModel {
    registrationNumber?: string | undefined;
    modelCode?: string | undefined;
    year?: number;
    chassiNumber17?: string | undefined;
    brand?: BrandViewModel;
    specialBrandCode?: string | undefined;
    specialBrand?: BrandViewModel;
}

export class ComponentMediaViewModel implements IComponentMediaViewModel {
    url?: string | undefined;
    displayName?: string | undefined;
    content?: string | undefined;
    mediaCategoryTypeName?: MediaCategoryTypeNameEnum;
    mediaTypeName?: MediaTypeNameEnum;
    layer?: string | undefined;

    constructor(data?: IComponentMediaViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.displayName = _data["displayName"];
            this.content = _data["content"];
            this.mediaCategoryTypeName = _data["mediaCategoryTypeName"];
            this.mediaTypeName = _data["mediaTypeName"];
            this.layer = _data["layer"];
        }
    }

    static fromJS(data: any): ComponentMediaViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentMediaViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["displayName"] = this.displayName;
        data["content"] = this.content;
        data["mediaCategoryTypeName"] = this.mediaCategoryTypeName;
        data["mediaTypeName"] = this.mediaTypeName;
        data["layer"] = this.layer;
        return data;
    }
}

export interface IComponentMediaViewModel {
    url?: string | undefined;
    displayName?: string | undefined;
    content?: string | undefined;
    mediaCategoryTypeName?: MediaCategoryTypeNameEnum;
    mediaTypeName?: MediaTypeNameEnum;
    layer?: string | undefined;
}

export class ComponentViewModel implements IComponentViewModel {
    componentId?: number;
    sectionId?: number;
    name?: string | undefined;
    technicalName?: string | undefined;
    media?: ComponentMediaViewModel[] | undefined;

    constructor(data?: IComponentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentId = _data["componentId"];
            this.sectionId = _data["sectionId"];
            this.name = _data["name"];
            this.technicalName = _data["technicalName"];
            if (Array.isArray(_data["media"])) {
                this.media = [] as any;
                for (let item of _data["media"])
                    this.media!.push(ComponentMediaViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ComponentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentId"] = this.componentId;
        data["sectionId"] = this.sectionId;
        data["name"] = this.name;
        data["technicalName"] = this.technicalName;
        if (Array.isArray(this.media)) {
            data["media"] = [];
            for (let item of this.media)
                data["media"].push(item.toJSON());
        }
        return data;
    }
}

export interface IComponentViewModel {
    componentId?: number;
    sectionId?: number;
    name?: string | undefined;
    technicalName?: string | undefined;
    media?: ComponentMediaViewModel[] | undefined;
}

/** Contact request model. */
export class ContactRequestModel implements IContactRequestModel {
    /** Phone. */
    phone?: string | undefined;
    /** Mobile phone. */
    mobilePhone?: string | undefined;
    /** Email. */
    email?: string | undefined;

    constructor(data?: IContactRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phone = _data["phone"];
            this.mobilePhone = _data["mobilePhone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ContactRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContactRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phone"] = this.phone;
        data["mobilePhone"] = this.mobilePhone;
        data["email"] = this.email;
        return data;
    }
}

/** Contact request model. */
export interface IContactRequestModel {
    /** Phone. */
    phone?: string | undefined;
    /** Mobile phone. */
    mobilePhone?: string | undefined;
    /** Email. */
    email?: string | undefined;
}

export class ContactViewModel implements IContactViewModel {
    phone?: string | undefined;
    mobilePhone?: string | undefined;
    email?: string | undefined;

    constructor(data?: IContactViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phone = _data["phone"];
            this.mobilePhone = _data["mobilePhone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ContactViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContactViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phone"] = this.phone;
        data["mobilePhone"] = this.mobilePhone;
        data["email"] = this.email;
        return data;
    }
}

export interface IContactViewModel {
    phone?: string | undefined;
    mobilePhone?: string | undefined;
    email?: string | undefined;
}

/** Create channel request request model. */
export class CreateChannelRequestRequestModel implements ICreateChannelRequestRequestModel {
    channel!: ChannelEnum;
    /** (Mandatory). Expiration date. */
    expirationDate!: Date;
    /** External system reference. */
    externalSystemReference?: string | undefined;
    /** Prepare. */
    prepare?: boolean;
    /** Brand code. Example: C. */
    brandCode?: string | undefined;
    /** Parties. */
    parties?: PartyRequestModel[] | undefined;
    vehicle?: VehicleRequestModel;
    /** Setup. */
    setup?: SetupModel[] | undefined;

    constructor(data?: ICreateChannelRequestRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channel = _data["channel"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.externalSystemReference = _data["externalSystemReference"];
            this.prepare = _data["prepare"];
            this.brandCode = _data["brandCode"];
            if (Array.isArray(_data["parties"])) {
                this.parties = [] as any;
                for (let item of _data["parties"])
                    this.parties!.push(PartyRequestModel.fromJS(item));
            }
            this.vehicle = _data["vehicle"] ? VehicleRequestModel.fromJS(_data["vehicle"]) : <any>undefined;
            if (Array.isArray(_data["setup"])) {
                this.setup = [] as any;
                for (let item of _data["setup"])
                    this.setup!.push(SetupModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateChannelRequestRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateChannelRequestRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channel"] = this.channel;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["externalSystemReference"] = this.externalSystemReference;
        data["prepare"] = this.prepare;
        data["brandCode"] = this.brandCode;
        if (Array.isArray(this.parties)) {
            data["parties"] = [];
            for (let item of this.parties)
                data["parties"].push(item.toJSON());
        }
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        if (Array.isArray(this.setup)) {
            data["setup"] = [];
            for (let item of this.setup)
                data["setup"].push(item.toJSON());
        }
        return data;
    }
}

/** Create channel request request model. */
export interface ICreateChannelRequestRequestModel {
    channel: ChannelEnum;
    /** (Mandatory). Expiration date. */
    expirationDate: Date;
    /** External system reference. */
    externalSystemReference?: string | undefined;
    /** Prepare. */
    prepare?: boolean;
    /** Brand code. Example: C. */
    brandCode?: string | undefined;
    /** Parties. */
    parties?: PartyRequestModel[] | undefined;
    vehicle?: VehicleRequestModel;
    /** Setup. */
    setup?: SetupModel[] | undefined;
}

/** Create channel request response model. */
export class CreateChannelRequestResponseModel implements ICreateChannelRequestResponseModel {
    /** Channel request id. */
    channelRequestId?: string;
    /** Shopping cart id. */
    shoppingCartId?: string;
    /** Expiration date. */
    expirationDate?: Date;

    constructor(data?: ICreateChannelRequestResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelRequestId = _data["channelRequestId"];
            this.shoppingCartId = _data["shoppingCartId"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateChannelRequestResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateChannelRequestResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelRequestId"] = this.channelRequestId;
        data["shoppingCartId"] = this.shoppingCartId;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        return data;
    }
}

/** Create channel request response model. */
export interface ICreateChannelRequestResponseModel {
    /** Channel request id. */
    channelRequestId?: string;
    /** Shopping cart id. */
    shoppingCartId?: string;
    /** Expiration date. */
    expirationDate?: Date;
}

export enum CreateOrderModeEnum {
    Default = "Default",
    NoPassingControl = "NoPassingControl",
}

/** Create order request model. */
export class CreateOrderRequestModel implements ICreateOrderRequestModel {
    /** (Mandatory). Shopping cart id. */
    shoppingCartId!: string;
    /** (Mandatory). Payment method type id. */
    paymentMethodTypeId?: number;
    /** Order message. */
    orderMessage?: string | undefined;
    /** Contact customer. */
    contactCustomer?: boolean;
    createOrderMode?: CreateOrderModeEnum;
    campaignCodeId?: number | undefined;

    constructor(data?: ICreateOrderRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shoppingCartId = _data["shoppingCartId"];
            this.paymentMethodTypeId = _data["paymentMethodTypeId"];
            this.orderMessage = _data["orderMessage"];
            this.contactCustomer = _data["contactCustomer"];
            this.createOrderMode = _data["createOrderMode"];
            this.campaignCodeId = _data["campaignCodeId"];
        }
    }

    static fromJS(data: any): CreateOrderRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shoppingCartId"] = this.shoppingCartId;
        data["paymentMethodTypeId"] = this.paymentMethodTypeId;
        data["orderMessage"] = this.orderMessage;
        data["contactCustomer"] = this.contactCustomer;
        data["createOrderMode"] = this.createOrderMode;
        data["campaignCodeId"] = this.campaignCodeId;
        return data;
    }
}

/** Create order request model. */
export interface ICreateOrderRequestModel {
    /** (Mandatory). Shopping cart id. */
    shoppingCartId: string;
    /** (Mandatory). Payment method type id. */
    paymentMethodTypeId?: number;
    /** Order message. */
    orderMessage?: string | undefined;
    /** Contact customer. */
    contactCustomer?: boolean;
    createOrderMode?: CreateOrderModeEnum;
    campaignCodeId?: number | undefined;
}

/** Create order response model. */
export class CreateOrderResponseModel implements ICreateOrderResponseModel {
    /** Order number. */
    orderNumber?: number | undefined;
    /** Exceptions. */
    exceptions?: ProductExceptionResponseModel[] | undefined;
    channelRequest?: ChannelRequestViewModel;

    constructor(data?: ICreateOrderResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNumber = _data["orderNumber"];
            if (Array.isArray(_data["exceptions"])) {
                this.exceptions = [] as any;
                for (let item of _data["exceptions"])
                    this.exceptions!.push(ProductExceptionResponseModel.fromJS(item));
            }
            this.channelRequest = _data["channelRequest"] ? ChannelRequestViewModel.fromJS(_data["channelRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrderResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNumber"] = this.orderNumber;
        if (Array.isArray(this.exceptions)) {
            data["exceptions"] = [];
            for (let item of this.exceptions)
                data["exceptions"].push(item.toJSON());
        }
        data["channelRequest"] = this.channelRequest ? this.channelRequest.toJSON() : <any>undefined;
        return data;
    }
}

/** Create order response model. */
export interface ICreateOrderResponseModel {
    /** Order number. */
    orderNumber?: number | undefined;
    /** Exceptions. */
    exceptions?: ProductExceptionResponseModel[] | undefined;
    channelRequest?: ChannelRequestViewModel;
}

/** Create shopping cart request model. */
export class CreateShoppingCartRequestModel implements ICreateShoppingCartRequestModel {
    /** (Mandatory) BrandId. Example: 1. */
    brandId?: number;
    channel!: ChannelEnum;
    /** External system reference. */
    externalSystemReference?: string | undefined;
    vehicle?: VehicleRequestModel;

    constructor(data?: ICreateShoppingCartRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brandId = _data["brandId"];
            this.channel = _data["channel"];
            this.externalSystemReference = _data["externalSystemReference"];
            this.vehicle = _data["vehicle"] ? VehicleRequestModel.fromJS(_data["vehicle"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateShoppingCartRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateShoppingCartRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brandId"] = this.brandId;
        data["channel"] = this.channel;
        data["externalSystemReference"] = this.externalSystemReference;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        return data;
    }
}

/** Create shopping cart request model. */
export interface ICreateShoppingCartRequestModel {
    /** (Mandatory) BrandId. Example: 1. */
    brandId?: number;
    channel: ChannelEnum;
    /** External system reference. */
    externalSystemReference?: string | undefined;
    vehicle?: VehicleRequestModel;
}

export class DealerCampaignProductViewModel implements IDealerCampaignProductViewModel {
    includedInCampaigns?: string[] | undefined;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IDealerCampaignProductViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["includedInCampaigns"])) {
                this.includedInCampaigns = [] as any;
                for (let item of _data["includedInCampaigns"])
                    this.includedInCampaigns!.push(item);
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DealerCampaignProductViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DealerCampaignProductViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.includedInCampaigns)) {
            data["includedInCampaigns"] = [];
            for (let item of this.includedInCampaigns)
                data["includedInCampaigns"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDealerCampaignProductViewModel {
    includedInCampaigns?: string[] | undefined;
    startDate?: Date;
    endDate?: Date;
}

export class DealerViewModel implements IDealerViewModel {
    dealerId?: number;
    brandId?: number;
    number?: string | undefined;
    name?: string | undefined;
    group?: number;
    postalCode?: string | undefined;
    streetAddress?: string | undefined;
    city?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    webSite?: string | undefined;
    longitude?: number;
    latitude?: number;
    organisationNumber?: string | undefined;

    constructor(data?: IDealerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealerId = _data["dealerId"];
            this.brandId = _data["brandId"];
            this.number = _data["number"];
            this.name = _data["name"];
            this.group = _data["group"];
            this.postalCode = _data["postalCode"];
            this.streetAddress = _data["streetAddress"];
            this.city = _data["city"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.webSite = _data["webSite"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.organisationNumber = _data["organisationNumber"];
        }
    }

    static fromJS(data: any): DealerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DealerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerId"] = this.dealerId;
        data["brandId"] = this.brandId;
        data["number"] = this.number;
        data["name"] = this.name;
        data["group"] = this.group;
        data["postalCode"] = this.postalCode;
        data["streetAddress"] = this.streetAddress;
        data["city"] = this.city;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["webSite"] = this.webSite;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["organisationNumber"] = this.organisationNumber;
        return data;
    }
}

export interface IDealerViewModel {
    dealerId?: number;
    brandId?: number;
    number?: string | undefined;
    name?: string | undefined;
    group?: number;
    postalCode?: string | undefined;
    streetAddress?: string | undefined;
    city?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    webSite?: string | undefined;
    longitude?: number;
    latitude?: number;
    organisationNumber?: string | undefined;
}

export enum DiscountTypeEnum {
    Fixed = "Fixed",
    Percentage = "Percentage",
}

export class EngineViewModel implements IEngineViewModel {
    engineLetter?: string | undefined;
    minFactoryInvoiceDate?: Date | undefined;
    maxFactoryInvoiceDate?: Date | undefined;

    constructor(data?: IEngineViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.engineLetter = _data["engineLetter"];
            this.minFactoryInvoiceDate = _data["minFactoryInvoiceDate"] ? new Date(_data["minFactoryInvoiceDate"].toString()) : <any>undefined;
            this.maxFactoryInvoiceDate = _data["maxFactoryInvoiceDate"] ? new Date(_data["maxFactoryInvoiceDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EngineViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EngineViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["engineLetter"] = this.engineLetter;
        data["minFactoryInvoiceDate"] = this.minFactoryInvoiceDate ? this.minFactoryInvoiceDate.toISOString() : <any>undefined;
        data["maxFactoryInvoiceDate"] = this.maxFactoryInvoiceDate ? this.maxFactoryInvoiceDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEngineViewModel {
    engineLetter?: string | undefined;
    minFactoryInvoiceDate?: Date | undefined;
    maxFactoryInvoiceDate?: Date | undefined;
}

export enum EquipmentCodeTypeEnum {
    Factory = "Factory",
    FactoryStandard = "FactoryStandard",
    Harbour = "Harbour",
    Local = "Local",
}

export class FindCampaignCodeResponse implements IFindCampaignCodeResponse {
    isValidCampaignCode?: boolean;
    campaignCodeDetails?: CampaignCodeResponse;

    constructor(data?: IFindCampaignCodeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValidCampaignCode = _data["isValidCampaignCode"];
            this.campaignCodeDetails = _data["campaignCodeDetails"] ? CampaignCodeResponse.fromJS(_data["campaignCodeDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FindCampaignCodeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FindCampaignCodeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValidCampaignCode"] = this.isValidCampaignCode;
        data["campaignCodeDetails"] = this.campaignCodeDetails ? this.campaignCodeDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFindCampaignCodeResponse {
    isValidCampaignCode?: boolean;
    campaignCodeDetails?: CampaignCodeResponse;
}

/** Coordinates model. */
export class GeoLocationModel implements IGeoLocationModel {
    /** Longitude */
    longitude?: number;
    /** Latitude */
    latitude?: number;

    constructor(data?: IGeoLocationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
        }
    }

    static fromJS(data: any): GeoLocationModel {
        data = typeof data === 'object' ? data : {};
        let result = new GeoLocationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        return data;
    }
}

/** Coordinates model. */
export interface IGeoLocationModel {
    /** Longitude */
    longitude?: number;
    /** Latitude */
    latitude?: number;
}

/** Key-value request model. */
export class KeyValueRequestModel implements IKeyValueRequestModel {
    /** Id. */
    id?: number | undefined;
    /** Name. */
    name?: string | undefined;

    constructor(data?: IKeyValueRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): KeyValueRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValueRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

/** Key-value request model. */
export interface IKeyValueRequestModel {
    /** Id. */
    id?: number | undefined;
    /** Name. */
    name?: string | undefined;
}

/** Log category visit request model. */
export class LogCatalogCategoryVisitRequestModel implements ILogCatalogCategoryVisitRequestModel {
    /** (Mandatory) Category id. */
    catalogCategoryId?: number;

    constructor(data?: ILogCatalogCategoryVisitRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.catalogCategoryId = _data["catalogCategoryId"];
        }
    }

    static fromJS(data: any): LogCatalogCategoryVisitRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new LogCatalogCategoryVisitRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["catalogCategoryId"] = this.catalogCategoryId;
        return data;
    }
}

/** Log category visit request model. */
export interface ILogCatalogCategoryVisitRequestModel {
    /** (Mandatory) Category id. */
    catalogCategoryId?: number;
}

/** Log product visit request model. */
export class LogProductVisitRequestModel implements ILogProductVisitRequestModel {
    /** (Mandatory) SKU. */
    sku!: string;

    constructor(data?: ILogProductVisitRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sku = _data["sku"];
        }
    }

    static fromJS(data: any): LogProductVisitRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new LogProductVisitRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        return data;
    }
}

/** Log product visit request model. */
export interface ILogProductVisitRequestModel {
    /** (Mandatory) SKU. */
    sku: string;
}

/** Log search request model. */
export class LogSearchRequestModel implements ILogSearchRequestModel {
    /** (Mandatory) Term. */
    term!: string;

    constructor(data?: ILogSearchRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.term = _data["term"];
        }
    }

    static fromJS(data: any): LogSearchRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new LogSearchRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term;
        return data;
    }
}

/** Log search request model. */
export interface ILogSearchRequestModel {
    /** (Mandatory) Term. */
    term: string;
}

export enum MediaCategoryTypeNameEnum {
    Thumb = "Thumb",
    Title = "Title",
    Caption = "Caption",
    Ingress = "Ingress",
    Body = "Body",
    Technical = "Technical",
    S = "S",
    M = "M",
    L = "L",
    Hero = "Hero",
    HREF = "HREF",
    Description = "Description",
    TechnicalDescription = "TechnicalDescription",
    ImageNameSmall = "ImageNameSmall",
    ImageNameMedium = "ImageNameMedium",
    ImageNameLarge = "ImageNameLarge",
    ProductName = "ProductName",
    Category = "Category",
    Disclaimer = "Disclaimer",
}

export enum MediaTypeNameEnum {
    Link = "Link",
    Image = "Image",
    Video = "Video",
    HTML = "HTML",
    Text = "Text",
    Button = "Button",
}

export class MediaViewModel implements IMediaViewModel {
    url?: string | undefined;
    displayName?: string | undefined;
    content?: string | undefined;
    mediaCategoryTypeName?: MediaCategoryTypeNameEnum;
    mediaTypeName?: MediaTypeNameEnum;

    constructor(data?: IMediaViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.displayName = _data["displayName"];
            this.content = _data["content"];
            this.mediaCategoryTypeName = _data["mediaCategoryTypeName"];
            this.mediaTypeName = _data["mediaTypeName"];
        }
    }

    static fromJS(data: any): MediaViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MediaViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["displayName"] = this.displayName;
        data["content"] = this.content;
        data["mediaCategoryTypeName"] = this.mediaCategoryTypeName;
        data["mediaTypeName"] = this.mediaTypeName;
        return data;
    }
}

export interface IMediaViewModel {
    url?: string | undefined;
    displayName?: string | undefined;
    content?: string | undefined;
    mediaCategoryTypeName?: MediaCategoryTypeNameEnum;
    mediaTypeName?: MediaTypeNameEnum;
}

export class MenuLinkViewModel implements IMenuLinkViewModel {
    id?: number;
    text?: string | undefined;
    href?: string | undefined;
    children?: MenuLinkViewModel[] | undefined;
    catalogCategory?: CatalogCategoryViewModelBase;

    constructor(data?: IMenuLinkViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.href = _data["href"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(MenuLinkViewModel.fromJS(item));
            }
            this.catalogCategory = _data["catalogCategory"] ? CatalogCategoryViewModelBase.fromJS(_data["catalogCategory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MenuLinkViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MenuLinkViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["href"] = this.href;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["catalogCategory"] = this.catalogCategory ? this.catalogCategory.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMenuLinkViewModel {
    id?: number;
    text?: string | undefined;
    href?: string | undefined;
    children?: MenuLinkViewModel[] | undefined;
    catalogCategory?: CatalogCategoryViewModelBase;
}

export class ModelGroupViewModel implements IModelGroupViewModel {
    modelGroupId?: number;
    name?: string | undefined;

    constructor(data?: IModelGroupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelGroupId = _data["modelGroupId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ModelGroupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ModelGroupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelGroupId"] = this.modelGroupId;
        data["name"] = this.name;
        return data;
    }
}

export interface IModelGroupViewModel {
    modelGroupId?: number;
    name?: string | undefined;
}

export class ModelViewModel implements IModelViewModel {
    modelCode?: string | undefined;
    year?: number;
    name?: string | undefined;
    modelGroupId?: number;
    engines?: EngineViewModel[] | undefined;

    constructor(data?: IModelViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelCode = _data["modelCode"];
            this.year = _data["year"];
            this.name = _data["name"];
            this.modelGroupId = _data["modelGroupId"];
            if (Array.isArray(_data["engines"])) {
                this.engines = [] as any;
                for (let item of _data["engines"])
                    this.engines!.push(EngineViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ModelViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ModelViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelCode"] = this.modelCode;
        data["year"] = this.year;
        data["name"] = this.name;
        data["modelGroupId"] = this.modelGroupId;
        if (Array.isArray(this.engines)) {
            data["engines"] = [];
            for (let item of this.engines)
                data["engines"].push(item.toJSON());
        }
        return data;
    }
}

export interface IModelViewModel {
    modelCode?: string | undefined;
    year?: number;
    name?: string | undefined;
    modelGroupId?: number;
    engines?: EngineViewModel[] | undefined;
}

export class NotFoundResult implements INotFoundResult {
    statusCode?: number;

    constructor(data?: INotFoundResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
        }
    }

    static fromJS(data: any): NotFoundResult {
        data = typeof data === 'object' ? data : {};
        let result = new NotFoundResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        return data;
    }
}

export interface INotFoundResult {
    statusCode?: number;
}

export enum PageTypeEnum {
    ThankYou = "ThankYou",
    NotFound = "NotFound",
    Start = "Start",
    Terms = "Terms",
    Search = "Search",
    Product = "Product",
    FAQ = "FAQ",
    Checkout = "Checkout",
    Category = "Category",
}

export class PageViewModel implements IPageViewModel {
    id?: number;
    pageId?: number;
    brandId?: number | undefined;
    media?: MediaViewModel[] | undefined;
    sections?: SectionViewModel[] | undefined;

    constructor(data?: IPageViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pageId = _data["pageId"];
            this.brandId = _data["brandId"];
            if (Array.isArray(_data["media"])) {
                this.media = [] as any;
                for (let item of _data["media"])
                    this.media!.push(MediaViewModel.fromJS(item));
            }
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(SectionViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PageViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PageViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pageId"] = this.pageId;
        data["brandId"] = this.brandId;
        if (Array.isArray(this.media)) {
            data["media"] = [];
            for (let item of this.media)
                data["media"].push(item.toJSON());
        }
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPageViewModel {
    id?: number;
    pageId?: number;
    brandId?: number | undefined;
    media?: MediaViewModel[] | undefined;
    sections?: SectionViewModel[] | undefined;
}

/** Party request model. */
export class PartyRequestModel implements IPartyRequestModel {
    /** Identity. */
    identity?: string | undefined;
    partyType!: PartyTypeEnum;
    /** (Mandatory). Name1. */
    name1!: string;
    /** Name2. */
    name2?: string | undefined;
    contact?: ContactRequestModel;
    address?: AddressRequestModel;

    constructor(data?: IPartyRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identity = _data["identity"];
            this.partyType = _data["partyType"];
            this.name1 = _data["name1"];
            this.name2 = _data["name2"];
            this.contact = _data["contact"] ? ContactRequestModel.fromJS(_data["contact"]) : <any>undefined;
            this.address = _data["address"] ? AddressRequestModel.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PartyRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PartyRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identity"] = this.identity;
        data["partyType"] = this.partyType;
        data["name1"] = this.name1;
        data["name2"] = this.name2;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data;
    }
}

/** Party request model. */
export interface IPartyRequestModel {
    /** Identity. */
    identity?: string | undefined;
    partyType: PartyTypeEnum;
    /** (Mandatory). Name1. */
    name1: string;
    /** Name2. */
    name2?: string | undefined;
    contact?: ContactRequestModel;
    address?: AddressRequestModel;
}

export enum PartyTypeEnum {
    Dealer = "Dealer",
    CustomerConsumer = "CustomerConsumer",
    CustomerCompany = "CustomerCompany",
}

export class PartyViewModel implements IPartyViewModel {
    partyId?: number;
    identity?: string | undefined;
    partyTypeId?: number;
    partyTypeName?: PartyTypeEnum;
    name1?: string | undefined;
    name2?: string | undefined;
    contact?: ContactViewModel;
    address?: AddressViewModel;

    constructor(data?: IPartyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partyId = _data["partyId"];
            this.identity = _data["identity"];
            this.partyTypeId = _data["partyTypeId"];
            this.partyTypeName = _data["partyTypeName"];
            this.name1 = _data["name1"];
            this.name2 = _data["name2"];
            this.contact = _data["contact"] ? ContactViewModel.fromJS(_data["contact"]) : <any>undefined;
            this.address = _data["address"] ? AddressViewModel.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PartyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PartyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partyId"] = this.partyId;
        data["identity"] = this.identity;
        data["partyTypeId"] = this.partyTypeId;
        data["partyTypeName"] = this.partyTypeName;
        data["name1"] = this.name1;
        data["name2"] = this.name2;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPartyViewModel {
    partyId?: number;
    identity?: string | undefined;
    partyTypeId?: number;
    partyTypeName?: PartyTypeEnum;
    name1?: string | undefined;
    name2?: string | undefined;
    contact?: ContactViewModel;
    address?: AddressViewModel;
}

export enum PriceTypeEnum {
    Central = "Central",
    Dealer = "Dealer",
    CalculatedBySystem = "CalculatedBySystem",
}

export class PriceViewModel implements IPriceViewModel {
    listPrice?: number;
    adjustmentAmount?: number;
    adjustmentPercentage?: number;
    salesPrice?: number;
    priceType?: PriceTypeEnum;
    validFrom?: Date;

    constructor(data?: IPriceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listPrice = _data["listPrice"];
            this.adjustmentAmount = _data["adjustmentAmount"];
            this.adjustmentPercentage = _data["adjustmentPercentage"];
            this.salesPrice = _data["salesPrice"];
            this.priceType = _data["priceType"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PriceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PriceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPrice"] = this.listPrice;
        data["adjustmentAmount"] = this.adjustmentAmount;
        data["adjustmentPercentage"] = this.adjustmentPercentage;
        data["salesPrice"] = this.salesPrice;
        data["priceType"] = this.priceType;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPriceViewModel {
    listPrice?: number;
    adjustmentAmount?: number;
    adjustmentPercentage?: number;
    salesPrice?: number;
    priceType?: PriceTypeEnum;
    validFrom?: Date;
}

export enum ProductActionEnum {
    Add = "Add",
    Update = "Update",
    Delete = "Delete",
}

/** Product exception response model. */
export class ProductExceptionResponseModel implements IProductExceptionResponseModel {
    /** SKU. */
    sku?: string | undefined;
    /** Product ID. */
    productId?: number;
    /** Suggested products. */
    suggestedProducts?: ProductViewModel[] | undefined;

    constructor(data?: IProductExceptionResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sku = _data["sku"];
            this.productId = _data["productId"];
            if (Array.isArray(_data["suggestedProducts"])) {
                this.suggestedProducts = [] as any;
                for (let item of _data["suggestedProducts"])
                    this.suggestedProducts!.push(ProductViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductExceptionResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductExceptionResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["productId"] = this.productId;
        if (Array.isArray(this.suggestedProducts)) {
            data["suggestedProducts"] = [];
            for (let item of this.suggestedProducts)
                data["suggestedProducts"].push(item.toJSON());
        }
        return data;
    }
}

/** Product exception response model. */
export interface IProductExceptionResponseModel {
    /** SKU. */
    sku?: string | undefined;
    /** Product ID. */
    productId?: number;
    /** Suggested products. */
    suggestedProducts?: ProductViewModel[] | undefined;
}

export class ProductFilter implements IProductFilter {
    productTags?: ProductTagFilterEnum[] | undefined;
    productTrademarks?: string[] | undefined;

    constructor(data?: IProductFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productTags"])) {
                this.productTags = [] as any;
                for (let item of _data["productTags"])
                    this.productTags!.push(item);
            }
            if (Array.isArray(_data["productTrademarks"])) {
                this.productTrademarks = [] as any;
                for (let item of _data["productTrademarks"])
                    this.productTrademarks!.push(item);
            }
        }
    }

    static fromJS(data: any): ProductFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ProductFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productTags)) {
            data["productTags"] = [];
            for (let item of this.productTags)
                data["productTags"].push(item);
        }
        if (Array.isArray(this.productTrademarks)) {
            data["productTrademarks"] = [];
            for (let item of this.productTrademarks)
                data["productTrademarks"].push(item);
        }
        return data;
    }
}

export interface IProductFilter {
    productTags?: ProductTagFilterEnum[] | undefined;
    productTrademarks?: string[] | undefined;
}

/** Product request model. */
export class ProductRequestModel implements IProductRequestModel {
    /** (Mandatory) SKU. */
    sku!: string;
    /** (Mandatory). Quantity. */
    quantity?: number;
    action?: ProductActionEnum;

    constructor(data?: IProductRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sku = _data["sku"];
            this.quantity = _data["quantity"];
            this.action = _data["action"];
        }
    }

    static fromJS(data: any): ProductRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["quantity"] = this.quantity;
        data["action"] = this.action;
        return data;
    }
}

/** Product request model. */
export interface IProductRequestModel {
    /** (Mandatory) SKU. */
    sku: string;
    /** (Mandatory). Quantity. */
    quantity?: number;
    action?: ProductActionEnum;
}

export class ProductSubsetViewModel implements IProductSubsetViewModel {
    product?: ProductViewModel;
    quantity?: number;

    constructor(data?: IProductSubsetViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"] ? ProductViewModel.fromJS(_data["product"]) : <any>undefined;
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): ProductSubsetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSubsetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IProductSubsetViewModel {
    product?: ProductViewModel;
    quantity?: number;
}

export enum ProductTagFilterEnum {
    ProductNew = "ProductNew",
    Campaign = "Campaign",
    AssembledAndReady = "AssembledAndReady",
    FocusProduct = "FocusProduct",
}

export class ProductTagViewModel implements IProductTagViewModel {
    sequence?: number;
    tag?: TagViewModel;
    ruleType?: RuleTypeEnum;

    constructor(data?: IProductTagViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sequence = _data["sequence"];
            this.tag = _data["tag"] ? TagViewModel.fromJS(_data["tag"]) : <any>undefined;
            this.ruleType = _data["ruleType"];
        }
    }

    static fromJS(data: any): ProductTagViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductTagViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sequence"] = this.sequence;
        data["tag"] = this.tag ? this.tag.toJSON() : <any>undefined;
        data["ruleType"] = this.ruleType;
        return data;
    }
}

export interface IProductTagViewModel {
    sequence?: number;
    tag?: TagViewModel;
    ruleType?: RuleTypeEnum;
}

export class ProductTypeViewModel implements IProductTypeViewModel {
    productTypeId?: number;
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: IProductTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productTypeId = _data["productTypeId"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ProductTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productTypeId"] = this.productTypeId;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IProductTypeViewModel {
    productTypeId?: number;
    name?: string | undefined;
    description?: string | undefined;
}

export class ProductUpSaleViewModel implements IProductUpSaleViewModel {
    product?: ProductViewModelBase;
    sortOrder?: number;
    type?: UpSaleTypeEnum;

    constructor(data?: IProductUpSaleViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"] ? ProductViewModelBase.fromJS(_data["product"]) : <any>undefined;
            this.sortOrder = _data["sortOrder"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ProductUpSaleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductUpSaleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["sortOrder"] = this.sortOrder;
        data["type"] = this.type;
        return data;
    }
}

export interface IProductUpSaleViewModel {
    product?: ProductViewModelBase;
    sortOrder?: number;
    type?: UpSaleTypeEnum;
}

export class ProductViewModel implements IProductViewModel {
    productId?: number;
    sku?: string | undefined;
    price?: PriceViewModel;
    media?: MediaViewModel[] | undefined;
    minimumQuantity?: number;
    maximumQuantity?: number | undefined;
    productType?: ProductTypeViewModel;
    vatType?: VatTypeViewModel;
    unitType?: UnitTypeViewModel;
    warehouseStockStatus?: WarehouseStockStatusEnum;
    isPackage?: boolean;
    assembledAndReady?: boolean;
    isNew?: boolean;
    isCampaign?: boolean;
    isGDPR?: boolean;
    trademark?: string | undefined;
    disclaimer?: string | undefined;
    agreementText?: string | undefined;
    campaign?: DealerCampaignProductViewModel;
    catalogCategoryIds?: number[] | undefined;
    productSubset?: ProductSubsetViewModel[] | undefined;
    productTags?: ProductTagViewModel[] | undefined;

    constructor(data?: IProductViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.sku = _data["sku"];
            this.price = _data["price"] ? PriceViewModel.fromJS(_data["price"]) : <any>undefined;
            if (Array.isArray(_data["media"])) {
                this.media = [] as any;
                for (let item of _data["media"])
                    this.media!.push(MediaViewModel.fromJS(item));
            }
            this.minimumQuantity = _data["minimumQuantity"];
            this.maximumQuantity = _data["maximumQuantity"];
            this.productType = _data["productType"] ? ProductTypeViewModel.fromJS(_data["productType"]) : <any>undefined;
            this.vatType = _data["vatType"] ? VatTypeViewModel.fromJS(_data["vatType"]) : <any>undefined;
            this.unitType = _data["unitType"] ? UnitTypeViewModel.fromJS(_data["unitType"]) : <any>undefined;
            this.warehouseStockStatus = _data["warehouseStockStatus"];
            this.isPackage = _data["isPackage"];
            this.assembledAndReady = _data["assembledAndReady"];
            this.isNew = _data["isNew"];
            this.isCampaign = _data["isCampaign"];
            this.isGDPR = _data["isGDPR"];
            this.trademark = _data["trademark"];
            this.disclaimer = _data["disclaimer"];
            this.agreementText = _data["agreementText"];
            this.campaign = _data["campaign"] ? DealerCampaignProductViewModel.fromJS(_data["campaign"]) : <any>undefined;
            if (Array.isArray(_data["catalogCategoryIds"])) {
                this.catalogCategoryIds = [] as any;
                for (let item of _data["catalogCategoryIds"])
                    this.catalogCategoryIds!.push(item);
            }
            if (Array.isArray(_data["productSubset"])) {
                this.productSubset = [] as any;
                for (let item of _data["productSubset"])
                    this.productSubset!.push(ProductSubsetViewModel.fromJS(item));
            }
            if (Array.isArray(_data["productTags"])) {
                this.productTags = [] as any;
                for (let item of _data["productTags"])
                    this.productTags!.push(ProductTagViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["sku"] = this.sku;
        data["price"] = this.price ? this.price.toJSON() : <any>undefined;
        if (Array.isArray(this.media)) {
            data["media"] = [];
            for (let item of this.media)
                data["media"].push(item.toJSON());
        }
        data["minimumQuantity"] = this.minimumQuantity;
        data["maximumQuantity"] = this.maximumQuantity;
        data["productType"] = this.productType ? this.productType.toJSON() : <any>undefined;
        data["vatType"] = this.vatType ? this.vatType.toJSON() : <any>undefined;
        data["unitType"] = this.unitType ? this.unitType.toJSON() : <any>undefined;
        data["warehouseStockStatus"] = this.warehouseStockStatus;
        data["isPackage"] = this.isPackage;
        data["assembledAndReady"] = this.assembledAndReady;
        data["isNew"] = this.isNew;
        data["isCampaign"] = this.isCampaign;
        data["isGDPR"] = this.isGDPR;
        data["trademark"] = this.trademark;
        data["disclaimer"] = this.disclaimer;
        data["agreementText"] = this.agreementText;
        data["campaign"] = this.campaign ? this.campaign.toJSON() : <any>undefined;
        if (Array.isArray(this.catalogCategoryIds)) {
            data["catalogCategoryIds"] = [];
            for (let item of this.catalogCategoryIds)
                data["catalogCategoryIds"].push(item);
        }
        if (Array.isArray(this.productSubset)) {
            data["productSubset"] = [];
            for (let item of this.productSubset)
                data["productSubset"].push(item.toJSON());
        }
        if (Array.isArray(this.productTags)) {
            data["productTags"] = [];
            for (let item of this.productTags)
                data["productTags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProductViewModel {
    productId?: number;
    sku?: string | undefined;
    price?: PriceViewModel;
    media?: MediaViewModel[] | undefined;
    minimumQuantity?: number;
    maximumQuantity?: number | undefined;
    productType?: ProductTypeViewModel;
    vatType?: VatTypeViewModel;
    unitType?: UnitTypeViewModel;
    warehouseStockStatus?: WarehouseStockStatusEnum;
    isPackage?: boolean;
    assembledAndReady?: boolean;
    isNew?: boolean;
    isCampaign?: boolean;
    isGDPR?: boolean;
    trademark?: string | undefined;
    disclaimer?: string | undefined;
    agreementText?: string | undefined;
    campaign?: DealerCampaignProductViewModel;
    catalogCategoryIds?: number[] | undefined;
    productSubset?: ProductSubsetViewModel[] | undefined;
    productTags?: ProductTagViewModel[] | undefined;
}

export class ProductViewModelBase implements IProductViewModelBase {
    productId?: number;
    sku?: string | undefined;
    price?: PriceViewModel;
    media?: MediaViewModel[] | undefined;
    minimumQuantity?: number;
    maximumQuantity?: number | undefined;
    productType?: ProductTypeViewModel;
    vatType?: VatTypeViewModel;
    unitType?: UnitTypeViewModel;
    warehouseStockStatus?: WarehouseStockStatusEnum;
    isPackage?: boolean;
    assembledAndReady?: boolean;
    isNew?: boolean;
    isCampaign?: boolean;
    isGDPR?: boolean;
    trademark?: string | undefined;
    disclaimer?: string | undefined;
    agreementText?: string | undefined;
    campaign?: DealerCampaignProductViewModel;
    catalogCategoryIds?: number[] | undefined;

    constructor(data?: IProductViewModelBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.sku = _data["sku"];
            this.price = _data["price"] ? PriceViewModel.fromJS(_data["price"]) : <any>undefined;
            if (Array.isArray(_data["media"])) {
                this.media = [] as any;
                for (let item of _data["media"])
                    this.media!.push(MediaViewModel.fromJS(item));
            }
            this.minimumQuantity = _data["minimumQuantity"];
            this.maximumQuantity = _data["maximumQuantity"];
            this.productType = _data["productType"] ? ProductTypeViewModel.fromJS(_data["productType"]) : <any>undefined;
            this.vatType = _data["vatType"] ? VatTypeViewModel.fromJS(_data["vatType"]) : <any>undefined;
            this.unitType = _data["unitType"] ? UnitTypeViewModel.fromJS(_data["unitType"]) : <any>undefined;
            this.warehouseStockStatus = _data["warehouseStockStatus"];
            this.isPackage = _data["isPackage"];
            this.assembledAndReady = _data["assembledAndReady"];
            this.isNew = _data["isNew"];
            this.isCampaign = _data["isCampaign"];
            this.isGDPR = _data["isGDPR"];
            this.trademark = _data["trademark"];
            this.disclaimer = _data["disclaimer"];
            this.agreementText = _data["agreementText"];
            this.campaign = _data["campaign"] ? DealerCampaignProductViewModel.fromJS(_data["campaign"]) : <any>undefined;
            if (Array.isArray(_data["catalogCategoryIds"])) {
                this.catalogCategoryIds = [] as any;
                for (let item of _data["catalogCategoryIds"])
                    this.catalogCategoryIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ProductViewModelBase {
        data = typeof data === 'object' ? data : {};
        let result = new ProductViewModelBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["sku"] = this.sku;
        data["price"] = this.price ? this.price.toJSON() : <any>undefined;
        if (Array.isArray(this.media)) {
            data["media"] = [];
            for (let item of this.media)
                data["media"].push(item.toJSON());
        }
        data["minimumQuantity"] = this.minimumQuantity;
        data["maximumQuantity"] = this.maximumQuantity;
        data["productType"] = this.productType ? this.productType.toJSON() : <any>undefined;
        data["vatType"] = this.vatType ? this.vatType.toJSON() : <any>undefined;
        data["unitType"] = this.unitType ? this.unitType.toJSON() : <any>undefined;
        data["warehouseStockStatus"] = this.warehouseStockStatus;
        data["isPackage"] = this.isPackage;
        data["assembledAndReady"] = this.assembledAndReady;
        data["isNew"] = this.isNew;
        data["isCampaign"] = this.isCampaign;
        data["isGDPR"] = this.isGDPR;
        data["trademark"] = this.trademark;
        data["disclaimer"] = this.disclaimer;
        data["agreementText"] = this.agreementText;
        data["campaign"] = this.campaign ? this.campaign.toJSON() : <any>undefined;
        if (Array.isArray(this.catalogCategoryIds)) {
            data["catalogCategoryIds"] = [];
            for (let item of this.catalogCategoryIds)
                data["catalogCategoryIds"].push(item);
        }
        return data;
    }
}

export interface IProductViewModelBase {
    productId?: number;
    sku?: string | undefined;
    price?: PriceViewModel;
    media?: MediaViewModel[] | undefined;
    minimumQuantity?: number;
    maximumQuantity?: number | undefined;
    productType?: ProductTypeViewModel;
    vatType?: VatTypeViewModel;
    unitType?: UnitTypeViewModel;
    warehouseStockStatus?: WarehouseStockStatusEnum;
    isPackage?: boolean;
    assembledAndReady?: boolean;
    isNew?: boolean;
    isCampaign?: boolean;
    isGDPR?: boolean;
    trademark?: string | undefined;
    disclaimer?: string | undefined;
    agreementText?: string | undefined;
    campaign?: DealerCampaignProductViewModel;
    catalogCategoryIds?: number[] | undefined;
}

export enum RuleTypeEnum {
    NONE = "NONE",
    Mandatory = "Mandatory",
    Optional = "Optional",
    Excluded = "Excluded",
    MinimumOneOf = "MinimumOneOf",
    ExcludeCombination = "ExcludeCombination",
}

export class SearchDealerRequestModel implements ISearchDealerRequestModel {
    brandId?: number;
    channel!: ChannelEnum;
    geoLocation?: GeoLocationModel;
    limit?: number | undefined;

    constructor(data?: ISearchDealerRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brandId = _data["brandId"];
            this.channel = _data["channel"];
            this.geoLocation = _data["geoLocation"] ? GeoLocationModel.fromJS(_data["geoLocation"]) : <any>undefined;
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): SearchDealerRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new SearchDealerRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brandId"] = this.brandId;
        data["channel"] = this.channel;
        data["geoLocation"] = this.geoLocation ? this.geoLocation.toJSON() : <any>undefined;
        data["limit"] = this.limit;
        return data;
    }
}

export interface ISearchDealerRequestModel {
    brandId?: number;
    channel: ChannelEnum;
    geoLocation?: GeoLocationModel;
    limit?: number | undefined;
}

export class SearchQueryModel implements ISearchQueryModel {
    query?: string | undefined;
    categoryId?: number | undefined;
    categoryIds?: number[] | undefined;
    usePassingControl?: boolean;
    includeProducts?: boolean;
    includeCategories?: boolean;
    overrideDeliveryDateValidation?: boolean;
    sortType?: SortTypeEnum;
    channelRequestId?: string;
    productFilters?: ProductFilter;
    channel?: string | undefined;
    channelSearchResultLimit?: number;

    constructor(data?: ISearchQueryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"];
            this.categoryId = _data["categoryId"];
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds!.push(item);
            }
            this.usePassingControl = _data["usePassingControl"];
            this.includeProducts = _data["includeProducts"];
            this.includeCategories = _data["includeCategories"];
            this.overrideDeliveryDateValidation = _data["overrideDeliveryDateValidation"];
            this.sortType = _data["sortType"];
            this.channelRequestId = _data["channelRequestId"];
            this.productFilters = _data["productFilters"] ? ProductFilter.fromJS(_data["productFilters"]) : <any>undefined;
            this.channel = _data["channel"];
            this.channelSearchResultLimit = _data["channelSearchResultLimit"];
        }
    }

    static fromJS(data: any): SearchQueryModel {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query;
        data["categoryId"] = this.categoryId;
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        data["usePassingControl"] = this.usePassingControl;
        data["includeProducts"] = this.includeProducts;
        data["includeCategories"] = this.includeCategories;
        data["overrideDeliveryDateValidation"] = this.overrideDeliveryDateValidation;
        data["sortType"] = this.sortType;
        data["channelRequestId"] = this.channelRequestId;
        data["productFilters"] = this.productFilters ? this.productFilters.toJSON() : <any>undefined;
        data["channel"] = this.channel;
        data["channelSearchResultLimit"] = this.channelSearchResultLimit;
        return data;
    }
}

export interface ISearchQueryModel {
    query?: string | undefined;
    categoryId?: number | undefined;
    categoryIds?: number[] | undefined;
    usePassingControl?: boolean;
    includeProducts?: boolean;
    includeCategories?: boolean;
    overrideDeliveryDateValidation?: boolean;
    sortType?: SortTypeEnum;
    channelRequestId?: string;
    productFilters?: ProductFilter;
    channel?: string | undefined;
    channelSearchResultLimit?: number;
}

/** Model for search result. */
export class SearchResultModel implements ISearchResultModel {
    /** Product ids */
    productIds?: number[] | undefined;
    /** Category ids */
    categoryIds?: number[] | undefined;

    constructor(data?: ISearchResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productIds"])) {
                this.productIds = [] as any;
                for (let item of _data["productIds"])
                    this.productIds!.push(item);
            }
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SearchResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productIds)) {
            data["productIds"] = [];
            for (let item of this.productIds)
                data["productIds"].push(item);
        }
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        return data;
    }
}

/** Model for search result. */
export interface ISearchResultModel {
    /** Product ids */
    productIds?: number[] | undefined;
    /** Category ids */
    categoryIds?: number[] | undefined;
}

/** Search vehicle request model. */
export class SearchVehicleRequestModel implements ISearchVehicleRequestModel {
    /** (Mandatory). RegNr. Example: ABC123. */
    regNr!: string;

    constructor(data?: ISearchVehicleRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.regNr = _data["regNr"];
        }
    }

    static fromJS(data: any): SearchVehicleRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new SearchVehicleRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regNr"] = this.regNr;
        return data;
    }
}

/** Search vehicle request model. */
export interface ISearchVehicleRequestModel {
    /** (Mandatory). RegNr. Example: ABC123. */
    regNr: string;
}

export enum SectionTypeNameEnum {
    Term = "Term",
    Footer = "Footer",
    Questions = "Questions",
    ContactWays = "ContactWays",
    LinkBlock = "LinkBlock",
}

export class SectionViewModel implements ISectionViewModel {
    sectionId?: number;
    name?: string | undefined;
    sectionTypeName?: SectionTypeNameEnum;
    media?: MediaViewModel[] | undefined;
    components?: ComponentViewModel[] | undefined;

    constructor(data?: ISectionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sectionId = _data["sectionId"];
            this.name = _data["name"];
            this.sectionTypeName = _data["sectionTypeName"];
            if (Array.isArray(_data["media"])) {
                this.media = [] as any;
                for (let item of _data["media"])
                    this.media!.push(MediaViewModel.fromJS(item));
            }
            if (Array.isArray(_data["components"])) {
                this.components = [] as any;
                for (let item of _data["components"])
                    this.components!.push(ComponentViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SectionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SectionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionId"] = this.sectionId;
        data["name"] = this.name;
        data["sectionTypeName"] = this.sectionTypeName;
        if (Array.isArray(this.media)) {
            data["media"] = [];
            for (let item of this.media)
                data["media"].push(item.toJSON());
        }
        if (Array.isArray(this.components)) {
            data["components"] = [];
            for (let item of this.components)
                data["components"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISectionViewModel {
    sectionId?: number;
    name?: string | undefined;
    sectionTypeName?: SectionTypeNameEnum;
    media?: MediaViewModel[] | undefined;
    components?: ComponentViewModel[] | undefined;
}

export class SettingViewModel implements ISettingViewModel {
    name?: string | undefined;
    value?: string | undefined;
    channel?: ChannelEnum;

    constructor(data?: ISettingViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
            this.channel = _data["channel"];
        }
    }

    static fromJS(data: any): SettingViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SettingViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["channel"] = this.channel;
        return data;
    }
}

export interface ISettingViewModel {
    name?: string | undefined;
    value?: string | undefined;
    channel?: ChannelEnum;
}

/** Setup request model. */
export class SetupModel implements ISetupModel {
    /** Code. */
    code?: string | undefined;
    /** Value. */
    value?: string | undefined;
    type?: SetupTypeEnum;

    constructor(data?: ISetupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.value = _data["value"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): SetupModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["value"] = this.value;
        data["type"] = this.type;
        return data;
    }
}

/** Setup request model. */
export interface ISetupModel {
    /** Code. */
    code?: string | undefined;
    /** Value. */
    value?: string | undefined;
    type?: SetupTypeEnum;
}

export enum SetupTypeEnum {
    CallBackUrl = "CallBackUrl",
}

export class SetupViewModel implements ISetupViewModel {
    code?: string | undefined;
    value?: string | undefined;
    type?: string | undefined;

    constructor(data?: ISetupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.value = _data["value"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): SetupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["value"] = this.value;
        data["type"] = this.type;
        return data;
    }
}

export interface ISetupViewModel {
    code?: string | undefined;
    value?: string | undefined;
    type?: string | undefined;
}

export class ShoppingCartItemViewModel implements IShoppingCartItemViewModel {
    shoppingCartItemId?: number;
    product?: ProductViewModel;
    quantity?: number;

    constructor(data?: IShoppingCartItemViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shoppingCartItemId = _data["shoppingCartItemId"];
            this.product = _data["product"] ? ProductViewModel.fromJS(_data["product"]) : <any>undefined;
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): ShoppingCartItemViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShoppingCartItemViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shoppingCartItemId"] = this.shoppingCartItemId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IShoppingCartItemViewModel {
    shoppingCartItemId?: number;
    product?: ProductViewModel;
    quantity?: number;
}

export class ShoppingCartViewModel implements IShoppingCartViewModel {
    shoppingCartId?: string;
    shoppingCartItems?: ShoppingCartItemViewModel[] | undefined;
    vehicle?: VehicleViewModel;
    externalSystemReference?: string | undefined;
    brandId?: number;

    constructor(data?: IShoppingCartViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shoppingCartId = _data["shoppingCartId"];
            if (Array.isArray(_data["shoppingCartItems"])) {
                this.shoppingCartItems = [] as any;
                for (let item of _data["shoppingCartItems"])
                    this.shoppingCartItems!.push(ShoppingCartItemViewModel.fromJS(item));
            }
            this.vehicle = _data["vehicle"] ? VehicleViewModel.fromJS(_data["vehicle"]) : <any>undefined;
            this.externalSystemReference = _data["externalSystemReference"];
            this.brandId = _data["brandId"];
        }
    }

    static fromJS(data: any): ShoppingCartViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShoppingCartViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shoppingCartId"] = this.shoppingCartId;
        if (Array.isArray(this.shoppingCartItems)) {
            data["shoppingCartItems"] = [];
            for (let item of this.shoppingCartItems)
                data["shoppingCartItems"].push(item.toJSON());
        }
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["externalSystemReference"] = this.externalSystemReference;
        data["brandId"] = this.brandId;
        return data;
    }
}

export interface IShoppingCartViewModel {
    shoppingCartId?: string;
    shoppingCartItems?: ShoppingCartItemViewModel[] | undefined;
    vehicle?: VehicleViewModel;
    externalSystemReference?: string | undefined;
    brandId?: number;
}

export enum SortTypeEnum {
    AlphabeticalAscending = "AlphabeticalAscending",
    AlphabeticalDescending = "AlphabeticalDescending",
    PriceAscending = "PriceAscending",
    PriceDescending = "PriceDescending",
}

export class TagGroupTypeViewModel implements ITagGroupTypeViewModel {
    tagGroupTypeId?: number;
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: ITagGroupTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagGroupTypeId = _data["tagGroupTypeId"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): TagGroupTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TagGroupTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagGroupTypeId"] = this.tagGroupTypeId;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface ITagGroupTypeViewModel {
    tagGroupTypeId?: number;
    name?: string | undefined;
    description?: string | undefined;
}

export class TagOwnerTypeViewModel implements ITagOwnerTypeViewModel {
    tagOwnerTypeId?: number;
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: ITagOwnerTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagOwnerTypeId = _data["tagOwnerTypeId"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): TagOwnerTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TagOwnerTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagOwnerTypeId"] = this.tagOwnerTypeId;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface ITagOwnerTypeViewModel {
    tagOwnerTypeId?: number;
    name?: string | undefined;
    description?: string | undefined;
}

export class TagTypeViewModel implements ITagTypeViewModel {
    tagTypeId?: number;
    description?: string | undefined;
    searchable?: boolean;
    name?: string | undefined;

    constructor(data?: ITagTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagTypeId = _data["tagTypeId"];
            this.description = _data["description"];
            this.searchable = _data["searchable"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TagTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TagTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagTypeId"] = this.tagTypeId;
        data["description"] = this.description;
        data["searchable"] = this.searchable;
        data["name"] = this.name;
        return data;
    }
}

export interface ITagTypeViewModel {
    tagTypeId?: number;
    description?: string | undefined;
    searchable?: boolean;
    name?: string | undefined;
}

export class TagViewModel implements ITagViewModel {
    tagId?: number;
    value?: string | undefined;
    tagOwnerType?: TagOwnerTypeViewModel;
    tagType?: TagTypeViewModel;
    tagGroupType?: TagGroupTypeViewModel;

    constructor(data?: ITagViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagId = _data["tagId"];
            this.value = _data["value"];
            this.tagOwnerType = _data["tagOwnerType"] ? TagOwnerTypeViewModel.fromJS(_data["tagOwnerType"]) : <any>undefined;
            this.tagType = _data["tagType"] ? TagTypeViewModel.fromJS(_data["tagType"]) : <any>undefined;
            this.tagGroupType = _data["tagGroupType"] ? TagGroupTypeViewModel.fromJS(_data["tagGroupType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TagViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TagViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagId"] = this.tagId;
        data["value"] = this.value;
        data["tagOwnerType"] = this.tagOwnerType ? this.tagOwnerType.toJSON() : <any>undefined;
        data["tagType"] = this.tagType ? this.tagType.toJSON() : <any>undefined;
        data["tagGroupType"] = this.tagGroupType ? this.tagGroupType.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITagViewModel {
    tagId?: number;
    value?: string | undefined;
    tagOwnerType?: TagOwnerTypeViewModel;
    tagType?: TagTypeViewModel;
    tagGroupType?: TagGroupTypeViewModel;
}

export class UnitTypeViewModel implements IUnitTypeViewModel {
    quantity?: number;
    suffix?: string | undefined;
    name?: string | undefined;

    constructor(data?: IUnitTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"];
            this.suffix = _data["suffix"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UnitTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UnitTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        data["suffix"] = this.suffix;
        data["name"] = this.name;
        return data;
    }
}

export interface IUnitTypeViewModel {
    quantity?: number;
    suffix?: string | undefined;
    name?: string | undefined;
}

export enum UpSaleTypeEnum {
    SpareParts = "SpareParts",
    Combination = "Combination",
    Required = "Required",
}

export class UpdateChannelRequestRequestModel implements IUpdateChannelRequestRequestModel {
    channelRequestId!: string;
    shoppingCartId?: string | undefined;
    expirationDate!: Date;
    externalSystemReference?: string | undefined;
    prepare?: boolean;
    brandId?: number | undefined;
    parties?: PartyRequestModel[] | undefined;
    vehicle?: VehicleRequestModel;
    setup?: SetupModel[] | undefined;

    constructor(data?: IUpdateChannelRequestRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelRequestId = _data["channelRequestId"];
            this.shoppingCartId = _data["shoppingCartId"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.externalSystemReference = _data["externalSystemReference"];
            this.prepare = _data["prepare"];
            this.brandId = _data["brandId"];
            if (Array.isArray(_data["parties"])) {
                this.parties = [] as any;
                for (let item of _data["parties"])
                    this.parties!.push(PartyRequestModel.fromJS(item));
            }
            this.vehicle = _data["vehicle"] ? VehicleRequestModel.fromJS(_data["vehicle"]) : <any>undefined;
            if (Array.isArray(_data["setup"])) {
                this.setup = [] as any;
                for (let item of _data["setup"])
                    this.setup!.push(SetupModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateChannelRequestRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateChannelRequestRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelRequestId"] = this.channelRequestId;
        data["shoppingCartId"] = this.shoppingCartId;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["externalSystemReference"] = this.externalSystemReference;
        data["prepare"] = this.prepare;
        data["brandId"] = this.brandId;
        if (Array.isArray(this.parties)) {
            data["parties"] = [];
            for (let item of this.parties)
                data["parties"].push(item.toJSON());
        }
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        if (Array.isArray(this.setup)) {
            data["setup"] = [];
            for (let item of this.setup)
                data["setup"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateChannelRequestRequestModel {
    channelRequestId: string;
    shoppingCartId?: string | undefined;
    expirationDate: Date;
    externalSystemReference?: string | undefined;
    prepare?: boolean;
    brandId?: number | undefined;
    parties?: PartyRequestModel[] | undefined;
    vehicle?: VehicleRequestModel;
    setup?: SetupModel[] | undefined;
}

/** Update channel request response model. */
export class UpdateChannelRequestResponseModel implements IUpdateChannelRequestResponseModel {
    /** Shopping cart id. */
    shoppingCartId?: string;
    /** Previous shopping cart id. */
    previousShoppingCartId?: string | undefined;
    /** Expiration date. */
    expirationDate?: Date;

    constructor(data?: IUpdateChannelRequestResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shoppingCartId = _data["shoppingCartId"];
            this.previousShoppingCartId = _data["previousShoppingCartId"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateChannelRequestResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateChannelRequestResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shoppingCartId"] = this.shoppingCartId;
        data["previousShoppingCartId"] = this.previousShoppingCartId;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        return data;
    }
}

/** Update channel request response model. */
export interface IUpdateChannelRequestResponseModel {
    /** Shopping cart id. */
    shoppingCartId?: string;
    /** Previous shopping cart id. */
    previousShoppingCartId?: string | undefined;
    /** Expiration date. */
    expirationDate?: Date;
}

/** Update shopping cart request model. */
export class UpdateShoppingCartRequestModel implements IUpdateShoppingCartRequestModel {
    /** (Mandatory). Shopping cart id. */
    shoppingCartId!: string;
    vehicle?: VehicleRequestModel;
    /** (Optional) Products. */
    products?: ProductRequestModel[] | undefined;

    constructor(data?: IUpdateShoppingCartRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shoppingCartId = _data["shoppingCartId"];
            this.vehicle = _data["vehicle"] ? VehicleRequestModel.fromJS(_data["vehicle"]) : <any>undefined;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ProductRequestModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateShoppingCartRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateShoppingCartRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shoppingCartId"] = this.shoppingCartId;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        return data;
    }
}

/** Update shopping cart request model. */
export interface IUpdateShoppingCartRequestModel {
    /** (Mandatory). Shopping cart id. */
    shoppingCartId: string;
    vehicle?: VehicleRequestModel;
    /** (Optional) Products. */
    products?: ProductRequestModel[] | undefined;
}

export class VatTypeViewModel implements IVatTypeViewModel {
    vatTypeId?: number;
    name?: string | undefined;
    description?: string | undefined;
    percentage?: number;

    constructor(data?: IVatTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vatTypeId = _data["vatTypeId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): VatTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VatTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vatTypeId"] = this.vatTypeId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["percentage"] = this.percentage;
        return data;
    }
}

export interface IVatTypeViewModel {
    vatTypeId?: number;
    name?: string | undefined;
    description?: string | undefined;
    percentage?: number;
}

/** Vehicle equipment specification request model. */
export class VehicleEquipmentSpecificationRequestModel implements IVehicleEquipmentSpecificationRequestModel {
    /** (Mandatory) Equipment code. */
    equipmentCode!: string;
    equipmentType!: EquipmentCodeTypeEnum;

    constructor(data?: IVehicleEquipmentSpecificationRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.equipmentCode = _data["equipmentCode"];
            this.equipmentType = _data["equipmentType"];
        }
    }

    static fromJS(data: any): VehicleEquipmentSpecificationRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleEquipmentSpecificationRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["equipmentCode"] = this.equipmentCode;
        data["equipmentType"] = this.equipmentType;
        return data;
    }
}

/** Vehicle equipment specification request model. */
export interface IVehicleEquipmentSpecificationRequestModel {
    /** (Mandatory) Equipment code. */
    equipmentCode: string;
    equipmentType: EquipmentCodeTypeEnum;
}

export class VehicleRequestModel implements IVehicleRequestModel {
    licensePlate?: string | undefined;
    vin?: string | undefined;
    modelCode?: string | undefined;
    year?: number;
    colorCode?: string | undefined;
    upholsteryCode?: string | undefined;
    engineLetter?: string | undefined;
    equipment?: VehicleEquipmentSpecificationRequestModel[] | undefined;

    constructor(data?: IVehicleRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licensePlate = _data["licensePlate"];
            this.vin = _data["vin"];
            this.modelCode = _data["modelCode"];
            this.year = _data["year"];
            this.colorCode = _data["colorCode"];
            this.upholsteryCode = _data["upholsteryCode"];
            this.engineLetter = _data["engineLetter"];
            if (Array.isArray(_data["equipment"])) {
                this.equipment = [] as any;
                for (let item of _data["equipment"])
                    this.equipment!.push(VehicleEquipmentSpecificationRequestModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VehicleRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licensePlate"] = this.licensePlate;
        data["vin"] = this.vin;
        data["modelCode"] = this.modelCode;
        data["year"] = this.year;
        data["colorCode"] = this.colorCode;
        data["upholsteryCode"] = this.upholsteryCode;
        data["engineLetter"] = this.engineLetter;
        if (Array.isArray(this.equipment)) {
            data["equipment"] = [];
            for (let item of this.equipment)
                data["equipment"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVehicleRequestModel {
    licensePlate?: string | undefined;
    vin?: string | undefined;
    modelCode?: string | undefined;
    year?: number;
    colorCode?: string | undefined;
    upholsteryCode?: string | undefined;
    engineLetter?: string | undefined;
    equipment?: VehicleEquipmentSpecificationRequestModel[] | undefined;
}

export class VehicleViewModel implements IVehicleViewModel {
    vehicleId?: number;
    licensePlate?: string | undefined;
    vin?: string | undefined;
    brandId?: number;
    modelGroupId?: number | undefined;
    modelGroupName?: string | undefined;
    modelId?: number | undefined;
    colorCode?: string | undefined;
    upholsteryCode?: string | undefined;
    modelCode?: string | undefined;
    year?: number;
    displayName?: string | undefined;
    engineLetter?: string | undefined;

    constructor(data?: IVehicleViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleId = _data["vehicleId"];
            this.licensePlate = _data["licensePlate"];
            this.vin = _data["vin"];
            this.brandId = _data["brandId"];
            this.modelGroupId = _data["modelGroupId"];
            this.modelGroupName = _data["modelGroupName"];
            this.modelId = _data["modelId"];
            this.colorCode = _data["colorCode"];
            this.upholsteryCode = _data["upholsteryCode"];
            this.modelCode = _data["modelCode"];
            this.year = _data["year"];
            this.displayName = _data["displayName"];
            this.engineLetter = _data["engineLetter"];
        }
    }

    static fromJS(data: any): VehicleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleId"] = this.vehicleId;
        data["licensePlate"] = this.licensePlate;
        data["vin"] = this.vin;
        data["brandId"] = this.brandId;
        data["modelGroupId"] = this.modelGroupId;
        data["modelGroupName"] = this.modelGroupName;
        data["modelId"] = this.modelId;
        data["colorCode"] = this.colorCode;
        data["upholsteryCode"] = this.upholsteryCode;
        data["modelCode"] = this.modelCode;
        data["year"] = this.year;
        data["displayName"] = this.displayName;
        data["engineLetter"] = this.engineLetter;
        return data;
    }
}

export interface IVehicleViewModel {
    vehicleId?: number;
    licensePlate?: string | undefined;
    vin?: string | undefined;
    brandId?: number;
    modelGroupId?: number | undefined;
    modelGroupName?: string | undefined;
    modelId?: number | undefined;
    colorCode?: string | undefined;
    upholsteryCode?: string | undefined;
    modelCode?: string | undefined;
    year?: number;
    displayName?: string | undefined;
    engineLetter?: string | undefined;
}

/** Verify shopping cart request model. */
export class VerifyShoppingCartRequestModel implements IVerifyShoppingCartRequestModel {
    /** Shopping cart id. */
    shoppingCartId?: string | undefined;

    constructor(data?: IVerifyShoppingCartRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shoppingCartId = _data["shoppingCartId"];
        }
    }

    static fromJS(data: any): VerifyShoppingCartRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyShoppingCartRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shoppingCartId"] = this.shoppingCartId;
        return data;
    }
}

/** Verify shopping cart request model. */
export interface IVerifyShoppingCartRequestModel {
    /** Shopping cart id. */
    shoppingCartId?: string | undefined;
}

export enum WarehouseStockStatusEnum {
    Low = "Low",
    Medium = "Medium",
    High = "High",
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}